<template>
  <div id="scroll-threshold-example">
    <div>
      <div class="mt-5" v-if="booking&&settings.options">
        <v-row class="">
          <v-col cols="12">
            <v-container style="max-width:900px" class="px-0">
                <v-row class="px-2">
                  
                  <v-col cols="12" md="12">
                    <div class="text-center">
                      <v-card
                        class="neu-glow pb-5"        
                      >
                        <template v-if="!$vuetify.theme.dark">
                          <v-img v-if="settings.options.logoDB"
                            :src="'/static/users/pictures/db/'+settings.options.logoDB"
                            :lazy-src="'/static/users/pictures/db/'+settings.options.logoDB"
                            max-width="350"
                            class="mx-auto"
                          >
                          </v-img>
                          <div  v-else style="font-family: cursive !important;" class="text-h2 mt-3 mb-1">{{settings.brand?settings.brand[0].toUpperCase() + settings.brand.substring(1):''}}</div>
                        </template>
                        <template v-else>
                          <v-img v-if="settings.options.logoDBW&&$vuetify.theme.dark"
                            :src="'/static/users/pictures/db/'+settings.options.logoDBW"
                            :lazy-src="'/static/users/pictures/db/'+settings.options.logoDBW"
                            max-width="350"
                            class="mx-auto"
                          >
                          </v-img>
                          <div  v-else style="font-family: cursive !important;" class="text-h2 mt-3 mb-1">{{settings.brand?settings.brand[0].toUpperCase() + settings.brand.substring(1):''}}</div>
                        </template>
                        <div v-if="booking.bookingId">
                          <div class="text-h6 mt-3 mb-1">{{$t(page+'.Hi')}} <span v-if="booking.firstName||booking.lastName" class="font-weight-bold">{{booking.firstName?booking.firstName:booking.lastName}}</span></div>
                          <div class="text-h6 mb-3">{{$t(page+'.Alter your Reservation')}}</div>
                        </div>
                        <!--<div v-else-if="WAVerification&&booking.lastName">-->
                          <div v-else-if="booking.firstName||booking.lastName">
                          <div class="text-h6 mt-3 mb-1">{{$t(page+'.Hi')}} <span v-if="booking.firstName||booking.lastName" class="font-weight-bold">{{booking.firstName?booking.firstName:booking.lastName}}!</span></div>
                          <div v-if="WAVerification===null" class="text-subtitle1 mb-3">{{$t(page+'.Happy to see you again')}}</div>
                          <div class="text-caption mb-3"><span style="cursor:pointer" :class="settings.options.color+' white--text px-1 rounded'" @click="removeUser(1)">{{$t(page+'.Reset')}}</span></div>
                        </div>
                        <div v-else>
                          <div class="text-h5 my-3">{{$t(page+'.Direct Booking Service')}}</div>
                          <div class="text-caption mb-3">({{$t(page+'.WhatsApp account required')}})</div>
                          <div v-if="faqs" class="text-caption mb-3">{{$t(page+'.First Experience? read the')}} <span style="cursor:pointer" :class="settings.options.color+' px-1 rounded'" @click="$vuetify.goTo('#faq', {duration:1000,offset:30})">FAQ</span></div>
                        </div>
                      </v-card>
                    </div> 
                  </v-col>
                  
                  <v-col cols="12" v-if="!bookableDays">
                    <v-card class="text-center neu-glow py-5">
                      <v-progress-circular indeterminate size="300" width="20" color="info"></v-progress-circular>
                    </v-card>
                  </v-col>
                  <v-col cols="12" v-else-if="expired&&expired.expired==1">
                    <v-card class="text-center neu-glow pa-5 orange darken-2 black--text ">
                      <v-card-text class="text-h4 font-weight-black">
                        {{$t(page+'.Sorry, service not active')}}
                      </v-card-text>
                      <v-card-text class="text-h5">
                        {{$t(page+'.Please contact us in the old way')}}
                      </v-card-text>
                    </v-card>
                  </v-col> 
                  <v-col cols="12" v-else-if="!successfulBooking&&bookableDays&&!bookableDays.find(d=>d.date==booking.date)">
                    <v-card class="text-center neu-glow pa-5 orange darken-2 black--text ">
                      <v-card-text class="text-h4 font-weight-black">
                        {{$t(page+'.Sorry, reservation Expired')}}
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <template v-else>                    
                    <template v-if="settings.options.carouselImages">
                      <!--<v-row>
                        <v-col cols="12">-->
                          <!--<v-card class="neu-glow mx-3 py-2 px-0 mt-3">-->
                            <v-carousel
                            class="mx-3 neu-glow mt-3 px-0"
                            cycle
                            height="400"
                            hide-delimiters
                            show-arrows-on-hover
                            >
                                <v-carousel-item
                                    v-for="(item, i) in settings.options.carouselImages.split(',')"
                                    :key="i"
                                    :src="'/static/users/pictures/slides/'+item"
                                >

                                </v-carousel-item>
                            </v-carousel>
                          <!--</v-card>-->
                          <!--
                          </v-col>
                        </v-row>-->
                    </template>
                    <v-col class=" mt-3 px-3">
                      <v-btn block  v-if="settings.options.DBFirstButtonEnabled=='1'&&settings.options.DBFirstButtonURL" :href="settings.options.DBFirstButtonURL" :class="' neu-glow'">
                        <!--<v-icon class="mr-3">mdi-silverware</v-icon>-->
                        {{
                          settings.options.DBFirstButtonTitle
                        }}
                      </v-btn>                      

                      <v-btn block v-if="settings.options.DBSecondButtonEnabled=='1'&&settings.options.DBSecondButtonURL" :href="settings.options.DBSecondButtonURL" :class="' neu-glow mt-5'">
                        <!--<v-icon class="mr-3">mdi-web</v-icon>-->
                        {{
                          settings.options.DBSecondButtonTitle
                        }}
                      </v-btn>                      
                    </v-col>                    
                    <template v-if="settings.options.minAge&&!isOlder(booking.birthdate,settings.options.minAge)">
                      <v-col cols="12" class=""> 
                        <v-card class="neu-glow">
                          <v-card-title>
                            <v-icon class="mr-3" color="info">
                              mdi-account-child
                            </v-icon>
                            {{$t(page+'.Age Verification')}} 
                          </v-card-title>
                          <v-card-text>
                            <div class="text-center mb-4">
                              <v-row>
                                <v-col cols="12" md="12" class="mt-1">
                                  <p class="">
                                    {{$t(page+'.Access is restricted to younger than') + ' ' + settings.options.minAge}}
                                  </p>
                                  <p class="mb-0">
                                    {{$t(page+'.Please enter your birthdate for Age Verification')}}
                                  </p>        
                                </v-col>
                                <v-col cols="12">
                                  <v-menu
                                    ref="menuBirthdate"
                                    v-model="menuBirthdate"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="booking.birthdate"
                                        :label="$t(page+'.Birthdate')"
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        dense
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hide-details
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      ref="birthdate"
                                      no-title
                                      first-day-of-week=1
                                      :locale="locale"
                                      v-model="booking.birthdate"
                                      :color="settings.options.color"
                                      :max="subtractYears(settings.options.minAge?settings.options.minAge/1-1/1:13)"
                                      :min="subtractYears(99)"
                                      @change="saveBirthdate"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </template>
                    <template v-if="settings.options.minAge&&booking.birthdate&&!isOlder(booking.birthdate,settings.options.minAge)">
                      <v-col cols="12" class=""> 
                        <v-card class="neu-glow ">
                          <v-card-title>
                            <v-icon class="mr-3" color="error">
                              mdi-alert-circle
                            </v-icon>
                            {{$t(page+'.Age Verification Failed')}} 
                          </v-card-title>
                          <v-card-text>
                            <div class="text-center mb-4">
                              <v-row>
                                <v-col cols="12" md="12" class="mt-1">
                                  <p class="text-h6">
                                    {{$t(page+'.Sorry, you are too young to book')}}
                                  </p>
                                </v-col>
                              </v-row>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </template>                    
                    <template v-if="!bookingRslt&&(WAVerificationStarted||WAVerification||booking.bookingId||settings.options.phoneNumberVerificationRequired=='0')">
                      <v-col cols="12" md="12" class="mt-n3">
                        <v-card
                          class="neu-glow"        
                        >
                          <v-card-title class="pb-0">
                            <v-icon class="mr-3">mdi-calendar-month</v-icon>
                            {{$t(page+'.When')}} 
                          </v-card-title>
                          <v-card-text>
                            <div class="text-center mt-3">
                            <v-date-picker
                                class="neu-glow"
                                v-model="booking.date"
                                :color="settings.options.color"
                                header-color=""
                                :locale="locale"
                                first-day-of-week=1
                                :min="bookableDays[0].date"
                                :max="bookableDays.slice(-1).date"
                                :allowed-dates="allowedDates"
                                :disabled="!WAVerificationStarted&&!WAVerification&&!booking.bookingId&&settings.options.phoneNumberVerificationRequired=='1'"
                              ></v-date-picker>                                          
                            </div>
                          </v-card-text>
                          <v-card-text v-if="settings&&settings.options.DBMessage">
                            <div class="text-center">
                              {{settings.options.DBMessage}}
                            </div>
                          </v-card-text>
                          <!--
                          <v-card-text>
                            <div v-if="booking.date&&bookableDays.find(d=>d.date==booking.date)&&bookableDays.find(d=>d.date==booking.date).isLUNCH_OPEN==0&&bookableDays.find(d=>d.date==booking.date).isDINNER_OPEN==0" class="text-h6 text-center my-1">
                                {{
                                  bookableDays.find(d=>d.date==booking.date).from?$t(page+'.'+bookableDays.find(d=>d.date==booking.date).message) + ' ' + $t(page+'.dal') + ' ' + bookableDays.find(d=>d.date==booking.date).from + ' '+ $t(page+'.al') + ' ' +bookableDays.find(d=>d.date==booking.date).to:$t(page+'.'+bookableDays.find(d=>d.date==booking.date).message) 
                                }}                        
                            </div>
                            <div v-if="booking.date&&!bookableDays.find(d=>d.date==booking.date)" class="text-h6 text-center my-1">
                                Oltre l'intervallo di Prenotazione ammesso.
                            </div>
                          </v-card-text>
                          -->
                        </v-card>    
                      </v-col>
                      <template v-if="settings.options.disableSameDayDirectBooking=='0'||settings.options.disableSameDayDirectBooking!=today||booking.date!=bookableDays[0].date">
                        <v-col cols="12" md="12" class="">
                          <v-card
                            class="neu-glow pb-5"
                          >
                            <v-card-title class="pb-0">
                              <v-icon class="mr-3">
                                mdi-account-multiple
                              </v-icon>
                              {{$t(page+'.How Many')}}
                              <!--
                              <div>
                                  {{bookableDays.filter(d=>d.date==booking.date).length}} | {{booking.date}} | {{!bookableDays.filter(d=>d.date==booking.date)}}
                              </div>
                              -->
                            </v-card-title>
                            <v-alert v-if="!booking.date">{{$t(page+'.select Date first')}}</v-alert>
                            <v-card-text class="mt-3 px-12">
                              <!--<div v-else class="mt-14">&nbsp;</div>-->
                              <div class="text-center pt-4">
                                <v-btn-toggle v-model="booking.covers" 
                                  :active-class="settings.options.color+' white--text'"
                                  class="flex-wrap justify-center transparent-bg"
                                >
                                  <!--<v-tooltip top  v-for="(c,c1) in settings.options.maxBookableCovers*1" :key="c1">-->
                                  <v-tooltip top  v-for="(c,c1) in Math.min(settings.max_bookable_by_combinations_indoor,settings.options.maxBookableCovers/1)" :key="c1">
                                    <template v-slot:activator="{ on, attrs }">  
                                      <v-col cols="3" md="3" class="pa-0" v-bind="attrs" v-on="on">
                                        <v-btn
                                          :value="c"
                                          :disabled="!booking.date||!bookableDays.find(d=>d.date===booking.date).isDAY_OPEN||bookableDays.filter(d=>d.date===booking.date).length===0"
                                          class="px-4 mr-2 mt-3 text-subtitle-1 neu-glow"
                                          @click="booking.slotId=null"
                                        >
                                          {{c}}
                                        </v-btn>
                                      </v-col>
                                    </template>
                                    <span>{{c +' '+ $t(c==1?page+'.adult':page+'.adults')}}</span>
                                  </v-tooltip>
                                </v-btn-toggle>
                                <div class="mt-4 mb-4">{{$t(page+'.adults and')}}</div>
                                <div class="text-center mx-0 px-0">
                                  <v-btn-toggle v-model="booking.children" mandatory
                                    :active-class="settings.options.color+' white--text'"
                                    class="flex-wrap justify-center transparent-bg"
                                    :class="$vuetify.theme.dark?'darkbg':'lightbg'"
                                  >
                                    <v-tooltip top  v-for="(c,c1) in [0,1,2,3]" :key="c1" disabled>
                                      <template v-slot:activator="{ on, attrs }">  
                                        <div class="col-3 pa-0" v-bind="attrs" v-on="on">                                 
                                      <v-btn
                                        :value="c"
                                        :disabled="!booking.date||!bookableDays.find(d=>d.date==booking.date).isDAY_OPEN"
                                        class="px-4 mr-2 mt-2 text-subtitle-1 neu-glow"
                                        @click="booking.slotId=null"
                                      >
                                      {{c}}
                                      </v-btn>
                                        </div>
                                      </template>
                                      <span>{{$t(page+'.Children(s)')}}</span>
                                    </v-tooltip>
                                  </v-btn-toggle>                 
                                </div>
                                <div v-if="booking.children==1" class="mt-2">{{$t(page+'.child requiring highchair')}}</div>
                                <div v-else class="mt-2">{{$t(page+'.children requiring highchair')}}</div>
                              </div>               
                            </v-card-text>
                            <v-card-text class="text-center">
                              <v-btn color="neu-glow" @click="dialog_more_than=true">
                                {{$t(page+'.more than') + ' '+ Math.min(settings.max_bookable_by_combinations_indoor,settings.options.maxBookableCovers).toString()}}?
                              </v-btn>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <template v-if="locations.filter(x=> (booking.date>=x.dateFrom&&booking.date<=x.dateTo)||!booking.date).length>1">
                          <v-col cols="12" md="12" class=""> 
                            <v-card class="neu-glow">
                              <v-card-title>
                                <v-icon class="mr-3">
                                  mdi-map-marker
                                </v-icon>
                                {{$t(page+'.In or Out')}} ?
                              </v-card-title>
                              <v-card-text>
                                <div class="text-center mb-4">
                                  <v-row>

                                    <v-col cols="12" md="12" class="mt-1">
                                      <v-btn-toggle borderless v-model="booking.locationId" :active-class="settings.options.color+' white--text'" class="d-flex flex-wrap transparent-bg justify-center">
                                        <v-btn
                                          v-for="(l,l2) in locations.filter(x=> (booking.date>=x.dateFrom&&booking.date<=x.dateTo)||!booking.date)" :key="l2"
                                          small
                                          block
                                          class="px-4 mr-2 my-5 text-subtitle-1 neu-glow"
                                          :value="l.locationId"
                                          :disabled="!booking.covers"
                                          height="37"
                                          @click="booking.slotId=null"
                                        >
                                          {{locationDescription(l)}}
                                        </v-btn>
                                      </v-btn-toggle>                                        
                                    </v-col>
                                    <v-col  v-if="tableSplittingAlert">
                                      <v-alert dense type="info"> {{tableSplittingMessage}}</v-alert>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </template>
                        <v-col cols="12" md="12" class="" v-if="meals"> 
                          <v-card class="neu-glow">                
                            <v-card-title>
                              <v-icon class="mr-3">
                                mdi-food
                              </v-icon>
                              {{$t(page+'.LunchOrDinner')}} ?                      
                            </v-card-title>
                            <v-card-text>
                              <div class="text-center mb-4">
                                <v-row>

                                  <v-col cols="12" md="12" class="mt-1"> 
                                    <v-btn-toggle borderless v-model="booking.mealId" :active-class="settings.options.color+' white--text'" class="d-flex flex-wrap transparent-bg justify-center">
                                      <div  v-for="(l,l2) in activeMeals()" :key="l2">
                                        <v-btn                                        
                                          small
                                          height="55"
                                          width="140"
                                          class="px-4 mr-2 my-5 text-subtitle-1 neu-glow"
                                          :value="l.mealId"
                                          :loading="loading"
                                          :disabled="!booking.locationId"
                                          @click="booking.slotId=null"
                                        >
                                          {{l.name}}
                                        </v-btn>
                                      </div>
                                    </v-btn-toggle>                                    
                                  </v-col>


                                </v-row>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="12" class="">                     
                          <v-card class="neu-glow" style="min-height:60px" :loading="loading?'info':null">                
                            <v-card-title>
                              <v-icon class="mr-3" :loading="loading">
                                mdi-clock-time-eight
                              </v-icon>
                              {{$t(page+'.What Time')}}? 
                            </v-card-title>
                            <v-card-text>
                              <div class="text-center" v-if="booking.mealId&&freeTables&&freeTables.length">
                                <v-row>
                                  <v-col cols="12" class="">
                                    <v-btn-toggle v-model="booking.slotId" active-class="info white--text" class="flex-wrap justify-center transparent-bg pb-4">
                                      <v-tooltip disabled top v-for="(ft,f1) in freeTables" :key="f1" >
                                        <template v-slot:activator="{ on, attrs }">  
                                          <div v-bind="attrs" v-on="on">
                                            <v-btn 
                                              small
                                              class="text-subtitle-1 mr-2 mt-4 neu-glow"
                                              :class="((ft.unassigned&&!ft.assigned||ft.totalCovers>ft.covers)&&booking.slotId!=ft.slotId)?'warning darken-2 ':''"
                                              :value="ft.slotId"
                                              height="55"
                                              width="140"
                                              :loading="loading"
                                              :disabled="((!ft.assigned||ft.unassigned||ft.totalCovers>ft.covers)&&settings.options.manageWaitingList==='0')||ft.covers<0"
                                              @click="processSlot(ft)"
                                            >
                                            <span>
                                              <div>{{ft.name}}</div>
                                              <div class="text-caption" v-html="ft.covers<0?$t(page+'.Unavailable'):(!ft.assigned&&ft.unassigned||ft.totalCovers>ft.covers)?(settings.options.manageWaitingList=='1'?$t(page+'.Waiting List'):$t(page+'.Sold Out')):ft.bonus?ft.bonus:$t(page+'.Available')"></div>
                                            </span>                                          
                                              <!--
                                            {{ft.name}}
                                            {{ft.soldOut||ft.totalCovers>ft.covers?(settings.options.manageWaitingList=='1'?'$t(page+'.Waiting List'):$t(page+'.Sold Out')):$t(page+'.Available')}}
                                            -->
                                            </v-btn>
                                          </div>
                                        </template>
                                        <span>{{ft.covers < 0 ? $t(page+'.Unavailable'):(!ft.assigned&&ft.unassigned||ft.totalCovers>ft.covers)?(settings.options.manageWaitingList=='1'?$t(page+'.Waiting List'):$t(page+'.Sold Out')):$t(page+'.Available')}}</span>
                                      </v-tooltip>                                      
                                    </v-btn-toggle>                                           
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <!--
                                  <v-col cols="12" v-if="freeTables.some(f=>f.soldOut===1||f.totalCovers>f.covers)&&settings.options.manageWaitingList=='1'">
                                    {{$t(page+'.Yellow buttons mean that there are no free tables, but you can sign in for the waiting list')}}
                                  </v-col>
                                  -->
                                  <v-col cols="12" v-if="locations.length>1&&freeTables.some(f=>f.soldOut===1||f.totalCovers>f.covers)">
                                    {{$t(page+'.If inside it is fully booked, check outside, or viceversa')}}
                                  </v-col>                              
                                </v-row>
                              </div>
                              <div v-else-if="tryToGetFreeSlots">
                                <v-row>
                                  <v-col cols="12" class="px-8">
                                    <v-alert dense type="orange" icon="mdi-information">
                                      <div>{{$t(page+'.No slots available for today at') + ' ' +  $t(page+'.'+meals.find(m=>m.mealId==booking.mealId).name)+ ': ' +$t(page+'.Select another day')}}</div>
                                    </v-alert> 
                                  </v-col>
                                </v-row>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="12" class="" v-if="paymentRequired&&freeTables&&booking.slotId&&!ppPaid">
                          <v-card class="neu-glow" style="min-height:60px">                
                            <v-card-title>
                              <v-icon class="mr-3">
                                mdi-cash
                              </v-icon>
                              {{settings.options.paypalIntent=='CAPTURE'?$t(page+'.Deposit'):$t(page+'.Deposit')}}
                            </v-card-title>
                            <div class="d-flex justify-center pb-3">
                              <v-card class="neu-glow mx-5">
                                <v-card-text>
                                  <p class="text-center" v-if="settings.options.paypalIntent=='CAPTURE'">{{$t(page+'.For this timeframe a Prepayment is required')}}</p>
                                  <p class="text-center" v-else>{{$t(page+'.For this timeframe a Deposit is required')}}</p>
                                  <!--
                                  <p class="text-center font-weight-black mb-0 ">
                                    ({{booking.covers}} x {{booking.deposit}})
                                  </p>
                                  -->
                                  <p class="text-center text-h3 font-weight-black mb-0 mt-3 info--text">
                                    {{booking.prepaidAmount}} €
                                  </p>
                                </v-card-text>
                                <v-card-text v-if="settings.options.showWarningBeforeBooking=='0'">
                                  <div class="text-center mt-4 mb-2">
                                    <v-row>
                                      <v-col cols="12" md="12" class="d-flex justify-center">
                                        <div
                                          style="width:100%"
                                          class=""
                                          ref="paypal_div"
                                        ></div>                                  
                                      </v-col>                              
                                    </v-row>
                                  </div>
                                </v-card-text>
                                
                                <v-card-text class="pt-0" v-if="!booking.forcedDeposit">
                                  <p class="text-center">
                                    {{$t(page+'.In case of No-Show the amount will be retained')}}
                                  </p>                                                      
                                </v-card-text>
                                
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" class="" v-if="foodStyles&&foodStyles.length">
                          <v-card class="neu-glow">
                            <v-card-title class="mb-0">
                              <v-icon class="mr-3">
                                mdi-clipboard-list
                              </v-icon>                    
                              {{$t(page+'.May I have')}}
                              <v-spacer></v-spacer>
                            </v-card-title>
                            <v-card-text>
                              <!--
                              <v-row  v-for="(r,i) in booking.foodStyles" :key="i">
                                <v-col cols="3" class="text-left py-2" >
                                  <v-icon v-bind="attrs" v-on="on">{{r.icon}}</v-icon>
                                  <v-simple-checkbox
                                    v-bind="attrs" v-on="on"
                                    v-model="booking.foodStyles[i].value"
                                    :label="$t(page+'.'+r.name)"
                                    :color="settings.options.color"
                                    :disabled="!booking.covers"
                                    class="mt-1 float-right"
                                  ></v-simple-checkbox>
                                </v-col>
                                <v-col cols="9" class="pt-3">
                                  <div v-html="r.description"></div>
                                 
                                </v-col>
                              </v-row>	
                              -->
                              <v-row  v-for="(r,i) in foodStyles" :key="i" class="ml-8">
                                <v-col cols="1" class="text-left py-0" >
                                  <v-icon v-bind="attrs" v-on="on">{{r.icon}}</v-icon>
                                </v-col>
                                <v-col cols="1" class="text-left py-0" >
                                  <v-checkbox
                                    v-bind="attrs" v-on="on"
                                    v-model="booking.foodStyles"
                                    :value="r.requestId"
                                    :color="settings.options.color"
                                    :disabled="!booking.covers"
                                    class="mt-0 float-right"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="9" class="pt-1">
                                  <div v-html="r.description"></div>
                                </v-col>
                              </v-row>	

                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" class="" v-if="requests&&requests.length">
                          <v-card class="neu-glow">
                            <v-card-title class="mb-0">
                              <v-icon class="mr-3">
                                mdi-clipboard-list
                              </v-icon>                    
                              {{$t(page+'.I will')}}
                              <v-spacer></v-spacer>
                            </v-card-title>
                            <v-card-text>
                              <!--
                              <v-row  v-for="(r,i) in booking.requests" :key="i">
                                <v-col cols="3" class="text-left py-2" >
                                  <v-icon v-bind="attrs" v-on="on">{{r.icon}}</v-icon>
                                  <v-simple-checkbox
                                    v-bind="attrs" v-on="on"
                                    v-model="booking.requests[i].value"
                                    :label="$t(page+'.'+r.name)"
                                    :color="settings.options.color"
                                    :disabled="!booking.covers"
                                    class="mt-1 float-right"
                                  ></v-simple-checkbox>
                                </v-col>
                                <v-col cols="9" class="pt-3">
                                  <div v-html="r.description"></div>
                                </v-col>
                              </v-row>
                              -->

                              <v-row  v-for="(r,i) in requests" :key="i" class="ml-8">
                                <v-col cols="1" class="text-left py-0 " >
                                  <v-icon v-bind="attrs" v-on="on">{{r.icon}}</v-icon>
                                </v-col>
                                <v-col cols="1" class="text-left py-0" >
                                  <v-checkbox
                                    v-bind="attrs" v-on="on"
                                    v-model="booking.requests"
                                    :value="r.requestId"
                                    :color="settings.options.color"
                                    :disabled="!booking.covers"
                                    class="mt-0 float-right"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="9" class="pt-1">
                                  <div v-html="r.description"></div>
                                  <!--<div v-html="$t(page+'.'+r.description)"></div>-->
                                </v-col>
                              </v-row>

                            </v-card-text>		  
                          </v-card>                      
                        </v-col>                      
                        <v-col cols="12" md="12" class="" >
                          <v-card class="neu-glow" style="min-height:60px">                
                            <v-card-title>
                              <v-icon class="mr-3">
                                mdi-magnify
                              </v-icon>
                              {{$t(page+'.Profiling')}}
                            </v-card-title>
                            <v-card-text class="pb-0">
                              <p class="text-justify">
                                {{$t(page+'.Supply some further information so to allow us to customize our offer to you')}}:
                              </p>
                            </v-card-text>
                            <v-card-text>
                              <div class="text-center">
                                <v-row>
                                  <v-col cols="12" md="12" class="d-flex justify-center mb-2 py-0" style="height:50px" v-if="settings.options.genderRequested=='1'||settings.options.genderRequired=='1'">
                                    <v-div v-if="$vuetify.breakpoint.mdAndUp" class="pt-2 pr-2">
                                      {{settings.options.genderRequired=='1'?$t(page+'.Gender')+' *':$t(page+'.Gender')}}
                                    </v-div>
                                    <v-radio-group
                                      class="mt-1"
                                      label=""
                                      v-model="booking.gender"
                                      row
                                      @change="changeGender()"
                                      :color="settings.options.color"
                                      hide-details
                                      ref="gender"
                                    >
                                      <v-radio
                                        :label="$t(page+'.Male')"
                                        value="male"
                                        :color="settings.options.color"
                                      ></v-radio>
                                      <v-radio
                                        :label="$t(page+'.Female')"
                                        value="female"
                                        :color="settings.options.color"
                                      ></v-radio>
                                      <v-radio
                                        :label="'ND'"
                                        value="unknown"
                                        :color="settings.options.color"
                                      ></v-radio>
                                    </v-radio-group>
                                  </v-col>
                                  <v-col cols="12" md="12" class="py-0" style="height:100px" v-if="(settings.options.childrenPresenceRequested=='1'||settings.options.childrenPresenceRequired=='1')">
                                    <v-row>
                                      <v-col cols="6" class="" style="height:68px">
                                        <v-alert outlined class="align-content-center" style="height:82px">
                                          Sono presenti Bambini ?
                                        </v-alert>
                                      </v-col>
                                      <v-col cols="6" style="height:68px">
                                        <v-alert outlined :color="booking.childrenPresence==null?'error':''">
                                          <v-btn-toggle
                                            v-model="booking.childrenPresence"
                                            background
                                            ref="childrenPresence"
                                            active-class="info"
                                          >
                                            <div>
                                              <v-btn min-width="100" class="mr-3 neu-glow" v-for="(a,ai) in [{name:'SI',value:1},{name:'NO',value:-1}]" :key="ai" :value="a.value">
                                                {{a.name}}
                                              </v-btn>
                                            </div>
                                          </v-btn-toggle>
                                        </v-alert>
                                      </v-col>                                       
                                    </v-row>
                                  </v-col>                                                                
                                  <v-col cols="12" md="12" class="py-0" v-if="(settings.options.postalCodeRequested=='1'||settings.options.postalCodeRequired=='1')&&booking.countryCode=='39'">
                                    <v-text-field
                                      prepend-inner-icon="mdi-map-marker"
                                      ref="postalCode"
                                      :color="settings.options.postalCodeRequired=='1'?'error':settings.options.color"
                                      :label="settings.options.postalCodeRequired=='1'?$t(page+'.Postal Code')+' *':$t(page+'.Postal Code')"
                                      v-model="booking.postalCode"
                                      name="postalCode"
                                      type="number"
                                      autocomplete="off"
                                      outlined
                                      :hint="settings.options.postalCodeRequired=='1'?$t(page+'.Mandatory'):$t(page+'.Optional')"
                                    ></v-text-field>  
                                  </v-col> 
                                  <v-col cols="12" md="12" class="py-0" v-if="settings.options.emailRequested=='1'||settings.options.emailRequired=='1'">
                                    <v-text-field
                                      prepend-inner-icon="mdi-at"
                                      :color="settings.options.emailRequired=='1'?'error':settings.options.color"
                                      :label="settings.options.emailRequired=='1'?$t(page+'.Email')+' *':$t(page+'.Email')"
                                      v-model="booking.email"
                                      name="email"
                                      autocomplete="off"
                                      outlined
                                      ref="email"
                                      :hint="settings.options.emailRequired=='1'?$t(page+'.Mandatory'):$t(page+'.Optional')"
                                    ></v-text-field>  
                                  </v-col> 
                                  <v-col cols="12" md="12" class="py-0" v-if="(settings.options.birthdateRequested=='1'||settings.options.birthdateRequired=='1'&&!booking.birthdate)||settings.options.minAge&&!booking.birthdate">
                                  
                                      <v-menu
                                        ref="menuBirthdate"
                                        v-model="menuBirthdate"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            :color="settings.options.birthdateRequired=='1'?'error':settings.options.color"
                                            v-model="booking.birthdate"
                                            :label="settings.options.birthdateRequired=='1'?$t(page+'.Birthdate')+' *':$t(page+'.Birthdate')"
                                            prepend-inner-icon="mdi-calendar"
                                            outlined
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :hint="$t(page+'.Supply us your birthdate: we have a gift for you')"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          ref="birthdate"
                                          no-title
                                          first-day-of-week=1
                                          :locale="locale"
                                          v-model="booking.birthdate"
                                          :color="settings.options.color"
                                          :max="subtractYears(13)"
                                          :min="subtractYears(99)"
                                          @change="saveBirthdate"
                                        ></v-date-picker>
                                      </v-menu>                               
                                  </v-col>
                                  <v-col cols="12" md="12" class="py-0" >
                                    <v-text-field
                                      prepend-inner-icon="mdi-comment"
                                      :color="settings.options.color"
                                      :label="$t(page+'.Hints')"
                                      v-model="booking.remarks"
                                      name="remarks"
                                      autocomplete="off"
                                      outlined                                    
                                      :hint="$t(page+'.Hints to make your visit unforgettable')"
                                    ></v-text-field>              
                                  </v-col>                               
                                </v-row>
                              </div>
                            </v-card-text>                  
                          </v-card>
                        </v-col>


                        <v-col v-if="!bookingRslt&&(!settings.options.minAge||isOlder(booking.birthdate,settings.options.minAge)||settings.options.phoneNumberVerificationRequired=='0')" cols="12" md="12" class="">
                            <v-card
                              v-if="!booking.bookingId&&!WAVerification"
                              class="neu-glow pb-3 pt-2"      
                            >
                              <v-card-text class="px-5 my-3 py-0" v-if="settings.options.phoneNumberVerificationRequired=='1'">
                                <v-card class="neu-glow m4-3">
                                  <v-card-text class="py-2">
                                    <v-col cols="12" md="12" class="mt-1 px-1 py-0 text-subtitle2 justify">
                                      {{$t(page+'.We need to verify if WhatsApp BUSINESS is enabled')}}: 
                                      {{$t(page+'.Please click YES in the message we will send you after filling the form')}}: 
                                    </v-col>
                                  </v-card-text>
                                </v-card>
                              </v-card-text>
                              <v-card-text class="px-5 py-3">
                                <v-row class="d-flex justify-center pt-2">
                                  <v-col cols="12" sm="12" md="5" class="pr-0">
                                    <v-select
                                      :color="settings.options.color"
                                      dense
                                      outlined
                                      v-model="booking.countryCode"
                                      :items="countries"
                                      :label="$t(page+'.Country Code')"
                                      hide-details
                                      :readonly="WAVerification||VMVerification"
                                      :item-text="item => item.name +'+'+ item.value"
                                    >
                                      <template v-slot:item="slotProps" >
                                        <i :class="['mr-2', 'em', slotProps.item.flag]"></i>
                                        {{slotProps.item.namel}} + {{slotProps.item.value}}
                                      </template>
                                      
                                      <template v-slot:selection="data">
                                        <i :class="['mr-2', 'em', data.item.flag]"></i>
                                        {{$vuetify.breakpoint.mdAndUp?data.item.namel+' + ':''}} {{data.item.value}}
                                      </template>
                                    </v-select>
                                  </v-col>                     
                                  <v-col cols="12" sm="12" md="7">
                                    <v-text-field
                                      ref="phone"
                                      prepend-inner-icon="mdi-whatsapp"
                                      :color="success"
                                      label="Numero WhatsApp"
                                      v-model="booking.phone"
                                      name="phone"
                                      type="tel"
                                      autocomplete="false"
                                      reverse
                                      hide-spin-buttons
                                      outlined
                                      dense
                                      required
                                      :counter="mobilePhoneRegex&&mobilePhoneRegex.find(m=>m.countryCode==booking.countryCode)?mobilePhoneRegex.find(m=>m.countryCode==booking.countryCode).maxLength:false"
                                      :hint="phoneRegexHints(booking.countryCode)"
                                      persistent-hint
                                      :rules="[is_ValidPhone(booking.phone,booking.countryCode)]"
                                      :readonly="WAVerification||VMVerification"
                                      ></v-text-field>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field
                                      prepend-inner-icon="mdi-account"
                                      :color="settings.options.color"
                                      :label="$t(page+'.First Name')"
                                      v-model="booking.firstName"
                                      name="firstName"
                                      autocomplete="off"
                                      outlined
                                      dense
                                      :readonly="booking.bookingId"
                                      :hint="$t(page+'.First Name only')"
                                      hide-details
                                      ref="firstName"
                                    ></v-text-field>  
                                  </v-col>
                                  <v-col cols="12" :class="settings.options.phoneNumberVerificationRequired=='1'&&!WAVerification?'':'mb-4'">
                                    <v-text-field
                                      prepend-inner-icon="mdi-account"
                                      :color="settings.options.color"
                                      :label="$t(page+'.Last Name')"
                                      v-model="booking.lastName"
                                      name="lastName"
                                      autocomplete="off"
                                      outlined
                                      dense
                                      :readonly="WAVerification"
                                      :hint="$t(page+'.Last Name only')"
                                      hide-details
                                      ref="lastName"
                                    ></v-text-field>  
                                  </v-col>                                 
                                  <v-col cols="12" md="12" v-if="settings.options.phoneNumberVerificationRequired=='1'&&!WAVerification">
                                    <v-btn 
                                      class="mb-3 py-5"
                                      block
                                      color="info"
                                      :loading="loading_verifyNumber"
                                      :disabled="errorPhone_status||!booking.phone||!booking.lastName"
                                      @click="verifyForWA()"
                                    >
                                      <v-icon class="pr-3">mdi-account-check</v-icon>
                                      {{$t(page+'.Verify')}}
                                    </v-btn>
                                  </v-col>                            
                                </v-row>                  
                              </v-card-text>
                            </v-card>
                        </v-col>


                        <v-col cols="12" class="" v-if="!booking.bookingId">
                          <v-card class="neu-glow">
                            <v-card-title>
                              <v-icon class="mr-3" color="info">
                                mdi-email-newsletter
                              </v-icon>
                              {{$t(page+'.Subscribe to our Promo')}} 
                            </v-card-title>
                            <v-card-text>
                              <v-row class="mx-4 pa-0">
                                <v-col :cols="$vuetify.breakpoint.smAndUp?10:12" class="pa-0 d-flex align-center justify-center">
                                  <div class="text-subtitle-1 text-center">{{$t(page+'.Subscribe to our Promo to receive offers, gifts and discounts')}}</div>
                                </v-col>    
                                <v-col :cols="$vuetify.breakpoint.smAndUp?2:12" class="pa-0 d-flex justify-center">
                                  <v-switch  class="d-flex align-center ml-2" :color="settings.options.color" inset v-model="booking.newsletter"></v-switch>
                                </v-col>
                                <!--
                                <v-col :cols="$vuetify.breakpoint.smAndUp?2:6" class="pa-0 mt-2 d-flex justify-center">
                                  <v-icon large class="d-flex info--text">{{booking.newsletter?'mdi-sale-outline':''}}</v-icon>
                                </v-col>
                                -->
                                              
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <template v-if="WAVerificationStarted&&WAStatusCode<4&&(settings.options.phoneNumberVerificationRequired=='1'||settings.options.WA_ResponseRequired=='1')">
                          <v-col cols="12" class=""> 
                            <v-card class="neu-glow">
                              <v-card-title>
                                <v-icon class="mr-3" color="error">
                                  mdi-alert-circle
                                </v-icon>
                                {{$t(page+'.WhatsApp not Enabled')}} 
                              </v-card-title>
                              <v-card-text>
                                <v-card class="neu-glow ma-2 px-4">
                                  <div class="text-center mb-4">
                                    <v-row>
                                      <v-col cols="12" md="12" class="mt-1">
                                        <p class="text-h6">
                                          {{$t(page+'.WhatsApp Business verification has failed')}}:<br> {{ $t(page+'.the number you entered is not valid or not binded to a WhatsApp account')}}
                                        </p>
                                      </v-col>
                                      <v-col cols="12" md="12" class="mt-0 pt-0">
                                        <p class="text-h6">
                                          {{$t(page+'.Try with another number')}}
                                        </p>
                                      </v-col>                                  
                                      <template>
                                        <v-col >
                                          <p class="text-h6 mb-0" v-if="settings.options.AIEnabled=='0'">
                                            {{$t(page+'.You can make your reservation by Phone: our Staff is at your service')}}
                                          </p>
                                          <p class="text-h6 mb-0" v-if="settings.options.AIEnabled=='1'">
                                            {{$t(page+'.You can make your reservation by Phone: our Virtual assistant will help you in the process')}}
                                          </p>                                            
                                        </v-col>
                                        <v-col cols="12" md="12" v-if="booking.currentTime>settings.options.pbxRecallTime||settings.options.AIEnabled=='1'">
                                          <div class="text-center">
                                            <v-btn class="neu-glow" :href="'tel:'+settings.options.bookingNumber">
                                              <v-icon color="info" class="mr-3">mdi-phone</v-icon>
                                              {{$t(page+'.Click Here to Call')}}
                                            </v-btn>
                                          </div>
                                        </v-col>
                                        <v-col cols="12" md="12" v-else-if="booking.currentTime<settings.options.pbxRecallTime&&settings.options.AIEnabled!='1'">
                                          <div class="text-center">
                                            <p class="text-h6 mb-0">
                                              {{$t(page+'.Please call')+ ' ' + settings.options.bookingNumber+ '<br />' + $t(page+'.after') + ' ' + settings.options.pbxRecallTime}}
                                            </p>                                          
                                          </div>
                                        </v-col>                                    
                                      </template>
                                    </v-row>
                                  </div>
                                </v-card>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </template>                     
                        <template v-else>
                          <v-col cols="12" md="12" >
                              <v-card
                                class="neu-glow"      
                              >                    
                                <v-card-title>
                                  <v-icon class="mr-3">
                                    mdi-format-list-checks
                                  </v-icon> 
                                  {{$t(page+'.Confirmation')}}
                                  <v-spacer></v-spacer>                   
                                </v-card-title>
                                <v-card-text>  
                                  <v-row class="mt-n2">
                             
                                    <template v-if="booking.date&&noProceed_messages&&!successfulBooking">
                                      <v-col cols="12" md="4" :key="i" v-for="(m,i) in noProceed_messages" class="py-0">
                                        <v-btn block dense class="error my-1" @click="$refs[m.ref].focus()" style="text-transform:capitalize">
                                          <v-icon class="mr-2">mdi-alert</v-icon>
                                          {{m.btn}}
                                        </v-btn>
                                      </v-col>
                                    </template>                            
                                    <v-col cols="12" class="font-weight-black py-0 pb-5">
                                      <v-row class="align-center">                                                            
                                        <v-col cols="12" md="12">
                                          <v-tooltip top :disabled="noProceed_messages.length==0" color="error">
                                            <template v-slot:activator="{ on, attrs }">
                                              <div v-bind="attrs" v-on="on">
                                                <v-btn :color="settings.options.color" block :loading="loading_book" :disabled="continue_button"  @click="proceed()">
                                                  {{booking.bookingId?$t(page+'.Confirm'):$t(page+'.Next')}}
                                                  <v-icon class="pl-3">mdi-step-forward-2</v-icon>
                                                </v-btn>
                                              </div>
                                            </template>
                                            <span>
                                              <div v-if="noProceed_messages.length>0">
                                                <div v-for="(m,i) in noProceed_messages" :key="i">
                                                {{ m.btn }}
                                                </div>
                                              </div>
                                            </span>
                                          </v-tooltip>
                                        </v-col>                                 
                                      </v-row>
                                    </v-col>                          
                                  </v-row>
                                </v-card-text>
                              </v-card>
                          </v-col>
                        </template>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="12" >
                          <v-card
                            class="neu-glow pb-5"
                          >
                            <v-card-title class="pb-0">
                              <v-icon class="mr-3">
                                mdi-phone
                              </v-icon>
                              {{$t(page+'.Call Us')}}
                            </v-card-title>                        
                            <v-col class="text-center" >
                              <p class="text-h6 mb-0">
                                {{$t(page+'.You can make your reservation by Phone')}}:
                              </p>
                              <p class="text-h6 mb-0" v-if="settings.options.AIEnabled=='0'">
                                {{$t(page+'.Our Staff is at your service')}}
                              </p>                              
                              <p class="text-h6 mb-0" v-if="settings.options.AIEnabled=='1'">
                                {{$t(page+'.Our Virtual assistant will help you in the process')}}
                              </p>                                            
                            </v-col>
                            <v-col cols="12" md="12">
                              <div class="text-center">
                                <v-btn class="neu-glow" :href="'tel:+39'+settings.options.bookingNumber">
                                  <v-icon color="info" class="mr-3">mdi-phone</v-icon>
                                  {{$t(page+'.Click Here to Call')}}
                                </v-btn>
                              </div>
                            </v-col>
                          </v-card> 
                        </v-col>                                    
                      </template>
                      <template v-if="!dialog_booked&&successfulBooking">
                        <v-col cols="12" class=""> 
                          <v-card class="neu-glow">
                            <v-card-title>
                              <v-icon class="mr-3" color="error">
                                mdi-alert-circle
                              </v-icon>
                              {{$t(page+'.Grazie per la preferenza')}} 
                            </v-card-title>
                            <v-card-text>
                              <v-card class="neu-glow ma-2 px-4">
                                <div class="text-center mb-4">
                                  <v-row>
                                    <v-col cols="12" md="12" class="mt-1">
                                      <p class="text-h6">
                                        Vedi Menu
                                      </p>
                                    </v-col>
                                    <v-col cols="12" md="12" class="mt-0 pt-0">
                                      <p class="text-h6">
                                        {{$t(page+'.Try with another number')}}
                                      </p>
                                    </v-col>                                  
                                  </v-row>
                                </div>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </template>
                      <v-col cols="12" md="12" class="text-center pb-0">
                        <div class="text-center text-caption neu-glow pa-4 mt-5 pb-3 ">
                          <div>{{$t(page+'.The personal data provided will be processed in compliance with current legislation as indicated in the Privacy Policy available')}}</div>
                          <v-btn x-small class="text-center text-uppercase info mt-2" href="https://www.ibookrestaurant.it/privacy">{{$t(page+'.here')}}</v-btn>
                          <div class="mt-2">
                        <v-tooltip top color="info" disabled>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <div class="text-caption mt-2">
                                {{$t(page+'.Click here to remove your personal data from our DataBase')}}
                              </div>
                              <v-btn x-small :color="settings.options.color" :loading="loading_optOut"  @click="optOut()">
                                {{$t(page+'.Remove Me')}}
                                <v-icon class="pl-3">mdi-account-cancel</v-icon>
                              </v-btn>
                            </div>
                          </template>
                          <span>
                          </span>
                        </v-tooltip>
                          </div>
                        </div>
                      </v-col>                                        
                    </template>
                  </template>
                </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" md="12" class="pt-0">
            <v-container style="max-width:900px">
              <v-card
                flat
                class="neu-glow px-3 pb-5"
                id="faq"
                v-if="faqs&&expired.expired==0"
              >
                <v-card-title class="text-h4 font-weight-black">FAQs</v-card-title>
                <v-expansion-panels v-if="faqs" class="neu-glow">
                  <v-expansion-panel
                    v-for="(item,i) in faqs"
                    :key="i"
                  >
                    <v-expansion-panel-header>
                      {{item.Q}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="neu-glow-inset pt-5 py-3">
                      <v-row>
                        <v-col cols="12">
                          <p class="mb-0" v-html="(item.A).replace('.','<br />')"></p>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-btn
      v-scroll="onScroll"
      v-show="scrollToTop"
      fab
      dark
      small
      fixed
      bottom
      right
      :color="settings.options.color"
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    
    <v-bottom-navigation
      color="orange"
      absolute
      hide-on-scroll
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500" 
      class="mt-3 mb-4" 
      style="position:unset"   
    >
      <v-btn :href="settings.options.facebookURL" v-if="settings.options.facebookURL">
        <span>Facebook</span>
        <v-icon color="#3b5998">fa fa-facebook</v-icon>
      </v-btn>
      <v-btn :href="settings.options.instagramURL" v-if="settings.options.instagramURL">
        <span>Instagram</span>
        <v-icon color="#C13584">fa fa-instagram</v-icon>
      </v-btn>
      <v-btn :href="settings.options.youtubeURL" v-if="settings.options.youtubeURL">
        <span>YouTube</span>
        <v-icon color="#c4302b">fa fa-youtube</v-icon>
      </v-btn>
      <v-btn :href="settings.options.linkedInURL" v-if="settings.options.linkedInURL">
        <span>LinkedIn</span>
        <v-icon color="#0077b5">fa fa-linkedin</v-icon>
      </v-btn>
      <v-btn :href="settings.options.tripAdvisorURL" v-if="settings.options.tripAdvisorURL">
        <span>TripAdvisor</span>
        <v-icon color="#00af87">fa fa-tripadvisor</v-icon>
      </v-btn>             
    </v-bottom-navigation>
    <div id="scroll-threshold-example">
      &nbsp;
    </div>

    <v-dialog v-model="dialog_warning_before_booking"
      max-width="500"
      content-class="mx-0"
      transition="dialog-bottom-transition"
      v-if="dialog_warning_before_booking"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h6">
          {{$t(page+'.Your Reservation')}}
          <v-spacer></v-spacer>
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" :disabled="paymentRequired&&!ppPaid" @click="dialog_warning_before_booking = false;process();">
                <v-icon color="info">mdi-thumb-up</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Book')}}</span>
          </v-tooltip>
          -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_warning_before_booking=false">
                <v-icon color="warning">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Abort')}}</span>
          </v-tooltip>                      
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-3 text-subtitle-1 text-center" v-if="booking.slotId&&settings.options.showSummaryInWarning=='1'">
          <v-card class="neu-glow mx-1 mt-2">
            <v-card-title>
              {{$t(page+'.Summary')}}
            </v-card-title>
            <v-card-text class="px-3 pb-3 text-subtitle-1">
              <v-card class="neu-glow mx-2 mb-2 px-4 py-4">
                <v-row>
                  <v-col cols="6" class="text-left pt-1 pb-2">{{$t(page+'.Phone')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold pt-1 pb-2">{{booking.phone?booking.phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left pt-1 pb-2">{{$t(page+'.DoW')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold pt-1 pb-2">{{new Intl.DateTimeFormat(settings.locale, { weekday: "long", timeZone: 'Europe/Rome' }).format(new Date(booking.date))}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left pt-1 pb-2">{{$t(page+'.Date')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold pt-1 pb-2">{{new Intl.DateTimeFormat(settings.locale, { month: "long",  day: "numeric", timeZone: 'Europe/Rome' }).format(new Date(booking.date))}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left pt-1 pb-2">{{$t(page+'.Time')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold pt-1 pb-2">{{freeTables.find(s=>s.slotId==booking.slotId).name}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left pt-1 pb-2">{{$t(page+'.Guests')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold pt-1 pb-2">{{booking.covers}} {{booking.children?' + '+booking.children:''}}</v-col>
                </v-row> 
                <v-row>
                  <v-col cols="6" class="text-left pt-1 pb-2">{{$t(page+'.Area')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold pt-1 pb-2">{{locations.find(l=>l.locationId==booking.locationId).name}}</v-col>
                </v-row>
                <v-row v-if="booking.waiting">
                  <v-col class="text-left pt-1 pb-2 shrink">{{$t(page+'.Status')}}</v-col>
                  <v-col class="text-right font-weight-bold error--text pt-1 pb-2 grow">{{$t(page+'.Waiting List') }}</v-col>
                </v-row>              
                <v-row v-if="booking.prepaidAmount">
                  <v-col v-if="settings.options.paypalIntent=='CAPTURE'" cols="6" class="text-left warning--text pt-1 pb-2">{{$t(page+'.Prepayment')}}</v-col>
                  <v-col v-else cols="6" class="text-left warning--text pt-1 pb-2">{{$t(page+'.Deposit')}}</v-col>
                  <v-col cols="6" class="text-right font-weight-bold warning--text pt-1 pb-2">{{booking.prepaidAmount}}</v-col>
                </v-row> 
              </v-card>                
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text class="pa-3 text-subtitle-1 text-center" v-if="warningMessage">
          <v-card class="neu-glow mx-4 mt-1">
            <v-card-text class="pa-3 text-subtitle-1">
              <div v-html="warningMessage"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text class="px-3 pt-0 pb-6 text-subtitle-1">
          <v-card class="neu-glow mx-1 mt-2">
            <v-card-text class="pa-3 px-8 text-subtitle-1 text-center" v-if="paymentRequired&&!ppPaid">
              <div
                style="width:100%"
                class=""
                ref="paypal_div"
              ></div>
            </v-card-text>
            <v-card-text class="text-center" v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"  class="neu-glow mr-2" :disabled="paymentRequired&&!ppPaid" @click="dialog_warning_before_booking = false;saveBooking();">
                  <v-icon class="mr-3" color="info">mdi-thumb-up</v-icon>
                  {{$t(page+'.Book')}}
                </v-btn>
              </template>
              <span>{{$t(page+'.Book')}}</span>
            </v-tooltip>
            </v-card-text> 
          </v-card>
        </v-card-text>
        <v-card-text class="px-3 pt-0 pb-6 text-subtitle-1">
          <v-card class="neu-glow mx-1 mt-2">
            <v-card-text class="pa-3 pb-5 text-subtitle-1 text-center">
              <div>{{$t(page+'.Proceeding, You declare to fully agree and accept our')}}
                <div>
                  <v-btn
                    small
                    class="transparent info--text mt-2"
                    @click="dialog_optIn_tos=1"
                  >
                    {{$t(page+'.Terms')}}
                  </v-btn> 
                  <span class="mx-3 mt-3">{{$t(page+'.and')}}</span>
                  <v-btn
                    small
                    class="transparent info--text mt-2"
                    @click="dialog_optIn=1"
                  >
                    {{$t(page+'.Privacy')}}
                  </v-btn>                                            
                </div>
              </div>
            </v-card-text>           
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialog_paypal" max-width="500">
      <v-card class="neu-glow" v-if="ppPaid">
        <v-card-title class="text-h6 font-weight-bold ">
          {{$t(page+'.Payment Successful')}}!
          <v-spacer></v-spacer>
          <v-tooltip top class="ml-3">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="noRetryBtn()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-img
            contain
            height="400"
            src="/static/ob-animated-isometric/online-transactions-animate.svg"
            lazy-src="/static/ob-animated-isometric/online-transactions-animate.svg"
          ></v-img>
          <div class="display-1 pb-6 font-weight-bold text-center">{{$t(page+'.Thank You')}}!</div>
        </v-card-text>
      </v-card>
      <v-card class="neu-glow" v-else-if="ppCancel">
        <v-card-title class="text-h6 font-weight-bold ">
          {{$t(page+'.Payment Cancelled')}}!
          <v-spacer></v-spacer>
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="retryBtn()">
                <v-icon color="success">mdi-repeat</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Retry')}}</span>
          </v-tooltip>
          -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow ml-3"  @click="noRetryBtn()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-img
            contain
            height="400"
            src="/static/ob-animated-isometric/cancel-animate.svg"
            lazy-src="/static/ob-animated-isometric/cancel-animate.svg"
          ></v-img>
        </v-card-text>
      </v-card> 
      <v-card class="neu-glow" v-else-if="ppError">
        <v-card-title class="text-h6 font-weight-bold ">
          {{$t(page+'.Payment Error')}}!
          <div v-if="error_message">{{error_message}}</div>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="retryBtn()">
                <v-icon color="success">mdi-repeat</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Retry')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow ml-3"  @click="noRetryBtn()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-img
            contain
            height="400"
            src="/static/ob-animated-isometric/503-error-service-unavailable-animate.svg"
            lazy-src="/static/ob-animated-isometric/503-error-service-unavailable-animate.svg"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!--
    <v-dialog v-model="dialog_wa_failed"
      width="500"
      transition="dialog-bottom-transition"
      content-class="mx-0 neu-glow"
      >
      <v-card>
        <v-card-title class="text-h6 font-weight-bold ">
          <div>{{$t(page+'.WhatsApp Failure')}}</div>  
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_wa_failed=0">
                <v-icon color="info">mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Error')}}</span>
          </v-tooltip>             
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-body-2 pt-4 px-2 pa-sm-2">
          <v-card class="ma-2 pa-3 neu-glow "> 
            <v-alert
              dense
              type="error"
              class="mb-2"
            >
              {{$t(page+'.Message not delivered')}}
            </v-alert>           
            <p class="justify mb-0" v-html="$t(page+'.Possible reasons')"></p>
            <ol class="mb-2">
              <li>
                <p class="justify mb-0" v-html="$t(page+'.WhatsApp is not enabled on this Number')+'.'"></p>
              </li>
              <li>
                <p class="justify mb-0" v-html="$t(page+'.You have not accepted yet the new WhatsApp Business Rules')"></p>
              </li>
              <li>
                <p class="justify mb-0">{{$t(page+'.Number')}} <strong class="error--text"> {{phone?phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</strong> {{$t(page+'.is wrong')}}</p>
              </li>
            </ol>
            <p class="justify my-1 success--text" v-html="$t(page+'.Hints')"></p>
            <ol>
              <li>
                <p class="justify mb-0" v-html="$t(page+'.If you do not have WhatsApp you have to call us')"></p>
              </li>
              <li>
                <p class="justify mb-0" v-html="$t(page+'.To accept WhatsApp Business Rules click on the following link, WhatsApp will open and send the message that appears')"></p>
                <div class="d-flex justify-center my-3">
                  <v-btn class="info" target="_blank" href="https://wa.me/393933282589/?text=OK">{{$t(page+'.Open WhatsApp')}}
                    <v-icon class="ml-3">mdi-whatsapp</v-icon>
                  </v-btn>
                </div>
                <div class="justify mb-0" v-html="$t(page+'.Then return here and click')"></div>
                <div class="d-flex justify-center my-3">
                  <v-btn :disabled="!resendMessageEnabled" class="info" @click="resendWA(bookingId_WA)">
                    {{$t(page+'.Resend Message')}}
                    <v-icon class="ml-3">mdi-send</v-icon>
                  </v-btn>
                </div>
              </li>
              <li>
                <p class="justify mb-3" v-html="$t(page+'.To change your number, just fill in the following field and click send')"></p>
              </li>
            </ol>
            <p class="d-flex justify-center mb-0">
              <v-text-field
                ref="phoneChanged"
                prepend-inner-icon="mdi-whatsapp"
                :color="success"
                label="Numero WhatsApp"
                v-model="booking.phoneChanged"
                name="phoneChanged"
                type="tel"
                autocomplete="false"
                reverse
                hide-spin-buttons
                outlined
                dense
                required
                :counter="mobilePhoneRegex&&mobilePhoneRegex.find(m=>m.countryCode==booking.countryCode)?mobilePhoneRegex.find(m=>m.countryCode==booking.countryCode).maxLength:false"
                :hint="phoneRegexHints(booking.countryCode)"
                persistent-hint
                :rules="[is_ValidPhone(booking.phoneChanged,booking.countryCode)]"
                >
              </v-text-field>
            </p>
            <p class="d-flex justify-center my-3">
              <v-btn :disabled="!resendMessageEnabled||!booking.phoneChanged||is_ValidPhone(booking.phoneChanged,booking.countryCode)!=true" class="info"  @click="changeNumber(bookingId_WA,booking.phoneChanged,booking.countryCode)">
                {{$t(page+'.Change Number')}}
                <v-icon class="ml-3">mdi-send</v-icon>
              </v-btn>
            </p>
          </v-card>          
        </v-card-text>
      </v-card>
    </v-dialog>
    -->

    <v-dialog v-model="dialog_booked"
      width="500"
      transition="dialog-bottom-transition"
      content-class="mx-0"
      v-if="open_confirm_dialog"
    >
      <v-card class="neu-glow" style="overflow:hidden">
        <template v-if="!bookingRslt">
          <v-card-title class="text-h6 font-weight-bold ">
            <div>{{$t(page+'.Processing')}}</div>  
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow">
                  <v-icon color="info">mdi-timer-sand</v-icon>
                </v-btn>
              </template>
              <span>{{$t(page+'.Wait')}}</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-body-2 pt-4 px-2 pa-sm-2">
            <v-card class="ma-2 py-3 px-5 neu-glow ">
                <p class="justify mb-1 text-h5" v-html="$t(page+'.Please wait:')"></p>
                <p class="justify mb-1" v-html="$t(page+'.We are saving your reservation and sending you the reminder via WhatsApp')"></p>
            </v-card>
            <v-card class="ma-2 py-3 px-5 neu-glow"> 
              <div class="d-flex justify-center">
                <v-progress-circular indeterminate size="200" width="12" color="info"></v-progress-circular>
              </div>
            </v-card>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-title class="text-h6 font-weight-bold ">
            <div v-if="(!bookingRslt.confirmed&&bookingRslt.listed!=true)||bookingRslt.bookingStatus=='unconfirmed'">  
              {{$t(page+'.Request Received')}}
            </div>
            <div v-else-if="booking.bookingId">
              {{$t(page+'.Changes Confirmed')}}
            </div>
            <div v-else>
              {{$t(page+'.Booking Confirmed')}}
            </div>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="open_confirm_dialog=false;reset()">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{$t(page+'.Close')}}</span>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-body-2 pt-4 px-2 pa-sm-2">
            <template v-if="checkingWADelivered==1">
              <v-card class="ma-2 py-3 px-5 neu-glow ">
                <p class="justify mb-1 text-h5" v-html="$t(page+'.Please wait:')"></p>
                <p class="justify mb-1" v-html="$t(page+'.We are checking if whatsapp message has been successfully delivered')"></p>
              </v-card>
              <v-card class="ma-2 py-3 px-5 neu-glow"> 
                <div class="d-flex justify-center">
                  <v-progress-circular indeterminate size="200" width="12" color="success"></v-progress-circular>
                </div>  
              </v-card>             
            </template>
            <template v-else>
              <v-card class="ma-2 pa-3 neu-glow "> 
                <!-- Require WA Confirmed and not Received yet  -->
                <template v-if="(settings.options.WA_ResponseRequired=='1'&&!bookingRslt.validated)">
                  <!-- WA Sent Failed  -->
                  <template v-if="!WADelivered">
                    <p class="text-center">
                      <v-icon color="error" style="font-size:160px">mdi-alert</v-icon>
                    </p>
                    <p class="text-center text-h5 warning--text">
                      {{$t(page+'.REQUEST RECEIVED')}}
                    </p>                    
                    <v-card class="ma-2 pa-3 neu-glow ">
                      <v-alert
                        dense
                        type="error"
                        class="mb-2"
                      >
                        {{$t(page+'.WhatsApp not delivered')}}
                      </v-alert>
                      <p>{{$t(page+'.We got your request for a reservation')}}</p>
                      <p v-html="$t(page+'.As new user, to confirm your request for a Reservation, you should click CONFIRM REQUEST button in the WhatsApp message we tried to sent you but you did not receive')"></p>
                      <p>{{$t(page+'.Answering to such message we sent you is a required action to confirm your reservation')}}</p>
                      {{$t(page+'.If you want to receive it')}}
                       <div class="d-flex justify-center my-3"><v-btn small class="error" @click="dialog_wa_failed=1">{{$t(page+'.Click Here')}}</v-btn></div>
                    </v-card>
                  </template>
                  <!-- WA Sent Succeeded  -->
                  <template v-else>
                    <p class="text-center">
                      <v-icon color="warning" style="font-size:160px">mdi-alert-circle</v-icon>
                    </p>                    
                    <p class="justify my-5 ma-2 px-2" v-html="$t(page+'.To confirm your request for a Reservation, click CONFIRM REQUEST button in the WhatsApp message you should have just received')"></p>
                      <v-alert
                        dense
                        type="success"
                        class="mb-2"
                      >
                        {{$t(page+'.WhatsApp delivered')}}
                      </v-alert>
                    <p class="info--text justify text-center mb-0 mt-3">{{$t(page+'.If you have not received it yet, it means that the number you entered')}}</p>
                    <p class="warning--text justify text-center mt-0">{{phone?phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</p>
                    <p class="info--text justify text-center mb-0">{{$t(page+'.was wrong')}}</p>
                  </template> 
                </template>
                <!-- send confirmation==1 -->
                <template v-else-if="settings.options.WA_sendBookingConfirmation=='1'">
                  <!-- waiting -->
                  <template v-if="bookingRslt.waiting">
                    <p class="text-center">
                      <v-icon color="warning" style="font-size:160px">mdi-check-circle</v-icon>
                    </p>
                    <p class="text-center text-h5 warning--text">
                      {{$t(page+'.WAITLISTED RESERVATION')}}
                    </p>
                    <p class="justify mb-5 ma-2 px-2">{{$t(page+'.Your reservation is NOT CONFIRMED yet')}}.</p>
                    <template v-if="!WADelivered">
                      <v-card class="ma-2 pa-3 neu-glow "> 
                        <v-alert
                          dense
                          type="warning"
                          class="mb-2"
                        >
                          {{$t(page+'.WhatsApp not delivered')}}
                        </v-alert> 
                        <p>
                          {{$t(page+'.Your request has been received and we are processing it')}}, 
                          {{$t(page+'.but you do not receive our WhatsApp messages and you will not receive the confirmation of your reservation')}}. 
                          {{$t(page+'.If you want to receive it')}}
                        </p>
                        <div class="d-flex justify-center my-3"><v-btn small class="warning" @click="dialog_wa_failed=1">{{$t(page+'.Click Here')}}</v-btn></div>
                      </v-card>
                    </template>
                    <!-- WA Sent Succeeded  -->
                    <template v-else>
                      <p class="justify mb-5 ma-2 px-2">
                        {{$t(page+'.We just sent you a summary via WhatsApp')}}.
                      </p>
                      <p class="justify mb-5 ma-2 px-2">{{$t(page+'.As soon as some table will free we will confirm your Reservation immediately')}}.</p>                      
                        <v-alert
                          dense
                          type="success"
                          class="mb-2"
                        >
                          {{$t(page+'.WhatsApp delivered')}}
                        </v-alert>
                      <p class="info--text justify text-center mb-0 mt-3">{{$t(page+'.If you have not received it yet, it means that the number you entered')}}</p>
                    <p class="warning--text justify text-center mt-0">{{phone?phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</p>
                    <p class="info--text justify text-center mb-0">{{$t(page+'.was wrong')}}</p>
                    </template>
                  </template> 
                  <!-- manual confirmation -->
                  <template v-else-if="!bookingId&&!bookingRslt.confirmed">
                    <p class="text-center">
                      <v-icon color="warning" style="font-size:160px">mdi-alert-circle</v-icon>
                    </p>
                    <p class="text-center text-h5 warning--text">
                      {{$t(page+'.UNCONFIRMED RESERVATION')}}
                    </p>
                    <template v-if="!WADelivered">
                      <v-card class="ma-2 pa-3 neu-glow "> 
                        <v-alert
                          dense
                          type="warning"
                          class="mb-2"
                        >
                          {{$t(page+'.WhatsApp not delivered')}}
                        </v-alert> 
                        <p>{{$t(page+'.Your request has been received and we are processing it')}}, 
                          {{$t(page+'.but you do not receive our WhatsApp messages and you will not receive the confirmation of your reservation')}}.
                          {{$t(page+'.If you want to receive it')}}
                        </p>                       
                        <div class="d-flex justify-center my-3"><v-btn small class="warning" @click="dialog_wa_failed=1">{{$t(page+'.Click Here')}}</v-btn></div>
                      </v-card>
                    </template>
                    <template v-else>
                      <p class="justify mb-5 ma-2 px-2">{{$t(page+'.We have received your request for a Reservation')}}.</p>
                      <p class="justify mb-5 ma-2 px-2">
                        {{$t(page+'.We just sent you a summary via WhatsApp')}}.
                      </p>
                      <p class="justify mb-5 ma-2 px-2">{{$t(page+'.We check availability and we confirm it ASAP')}}.</p>
                      <v-alert
                        dense
                        type="success"
                        class="mb-2"
                      >
                        {{$t(page+'.WhatsApp delivered')}}
                      </v-alert>
                      <p class="info--text justify text-center mb-0 mt-3">{{$t(page+'.If you have not received it yet, it means that the number you entered')}}</p>
                      <p class="warning--text justify text-center mt-0">{{phone?phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</p>
                      <p class="info--text justify text-center mb-0">{{$t(page+'.was wrong')}}</p>
                    </template> 
                  </template>
                  <!-- ALTER  -->
                  <template v-else-if="bookingId&&!bookingRslt.confirmed">
                    <p class="text-center">
                      <v-icon color="warning" style="font-size:160px">mdi-alert-circle</v-icon>
                    </p>
                    <p class="text-center text-h5 warning--text">
                      {{$t(page+'.UNCONFIRMED RESERVATION')}}
                    </p>
                    <template v-if="!WADelivered">
                      <v-card class="ma-2 pa-3 neu-glow "> 
                        <v-alert
                          dense
                          type="warning"
                          class="mb-2"
                        >
                          {{$t(page+'.WhatsApp not delivered')}}
                        </v-alert> 
                        <p>{{$t(page+'.Your request has been received and we are processing it')}}, 
                          {{$t(page+'.but you do not receive our WhatsApp messages and you will not receive the confirmation of your reservation')}}
                          {{$t(page+'.If you want to receive it')}}
                        </p>                       
                        <div class="d-flex justify-center my-3"><v-btn small class="warning" @click="dialog_wa_failed=1">{{$t(page+'.Click Here')}}</v-btn></div>
                      </v-card>                    
                    </template>
                    <template v-else>
                      <p class="justify mb-5 ma-2 px-2">{{$t(page+'.We have received your request to alter your Reservation')}}.</p>
                      <p class="justify mb-5 ma-2 px-2">{{$t(page+'.We check availability and we confirm it ASAP')}}.</p>
                      <p class="justify mb-5 ma-2 px-2">
                        {{$t(page+'.We just sent you a summary via WhatsApp')}}.
                      </p>                      
                      <v-alert
                        dense
                        type="success"
                        class="mb-2"
                      >
                        {{$t(page+'.WhatsApp delivered')}}
                      </v-alert>
                      <p class="info--text justify text-center mb-0 mt-3">{{$t(page+'.If you have not received it yet, it means that the number you entered')}}</p>
                      <p class="warning--text justify text-center mt-0">{{phone?phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</p>
                     <p class="info--text justify text-center mb-0">{{$t(page+'.was wrong')}}</p>  
                    </template>                     
                  </template>
                  <!-- confirmed  --> 
                  <template v-else>
                    <p class="text-center">
                      <v-icon color="success" style="font-size:160px">mdi-check-circle</v-icon>
                    </p>
                    <p class="text-center text-h5 success--text">
                      {{$t(page+'.CONFIRMED RESERVATION')}}
                    </p>
                    <p v-if="bookingId" class="text-body-2 text-center">
                      {{$t(page+'.Thank you for altering your Reservation')}}
                    </p>
                    <p v-else class="text-body-2 text-center">
                      {{$t(page+'.Thank you for your Reservation')}}
                    </p>
                    <template>
                      <template v-if="!WADelivered">
                        <v-card class="ma-2 py-3 px-5 neu-glow ">
                        <v-alert
                          dense
                          type="info"
                          class="mb-2"
                        >
                          {{$t(page+'.WhatsApp not delivered')}}
                        </v-alert> 
                        <p class="justify mb-5 ma-2 px-2">{{$t(page+'.We just tried to sent you a summary via WhatsApp but it failed')}}.</p>                      
                          <p>
                            {{$t(page+'.Your reservation is anyway CONFIRMED')}}, 
                            {{$t(page+'.but from our WhatsApp messages you can edit your reservation and much more')}}. 
                            {{$t(page+'.If you want to receive it')}}
                          </p>
                          <div class="d-flex justify-center my-3"><v-btn small class="info" @click="dialog_wa_failed=1">{{$t(page+'.Click Here')}}</v-btn></div>
                        </v-card>
                      </template> 
                      <template v-else>
                        <p class="justify mb-5 ma-2 px-2">{{$t(page+'.We just sent you a summary via WhatsApp')}}.</p>
                        <p class="justify mb-5 ma-2 px-2">{{$t(page+'.Along with it, you will find the instruction to manage your reservation')}}</p>                        
                        <v-alert
                          dense
                          type="success"
                          class="mb-2"
                        >
                          {{$t(page+'.WhatsApp message delivered')}}
                        </v-alert>
                        <p class="info--text justify text-center mb-0 mt-3">{{$t(page+'.If you have not received it yet, it means that the number you entered')}}</p>
                        <p class="warning--text justify text-center mt-0">{{phone?phone.toString().replace(/\d{3,4}?(?=...)/g, '$& '):''}}</p>
                        <p class="info--text justify text-center mb-0">{{$t(page+'.was wrong')}}</p>
                      </template>                                        
                    </template>
                    <v-card-text v-if="settings.options.menuURL&&!bookingId">
                      <div class="text-center mb-3">
                        <v-btn :href="settings.options.menuURL" :class="settings.options.color+' elevation-8'" @click="open_confirm_dialog=false;reset()">
                          <v-icon>mdi-silverware</v-icon>
                          {{$t(page+'.Browse our Menu')}}
                        </v-btn>
                      </div>
                    </v-card-text>                  
                  </template>
                </template>
              </v-card> 
            </template>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_more_than"
      width="420"
      content-class="neu-glow"
    >
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          {{$t(page+'.Bulk Booking')}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="dialog_more_than=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>        
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pt-2">
          <v-card class="mx-5 neu-glow-inset">
            <v-card-text class="text-center text-subtitle-1">
              {{$t(page+'.For bookings above') +' ' + Math.min(settings.max_bookable_by_combinations_indoor,settings.options.maxBookableCovers).toString() + ' ' + $t(page+'.guests, please call') + ' ' + settings.options.phoneBookingNumber+' '+$t(page+'.after')+' '+settings.options.pbxRecallTime }}
            </v-card-text>
              <v-card-text class="text-center">
                <v-btn class="neu-glow" :href="'tel:'+settings.options.phoneBookingNumber">
                  <v-icon color="success">mdi-phone</v-icon>
                  {{$t(page+'.Call')}}
                </v-btn>
              </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog> 

    <v-dialog v-model="dialog_waitingListTime" 
      content-class="neu-glow mx-2" 
      persistent
      width="420"
      v-if="settings.options.manageWaitingList==1&&booking.waiting"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h6 font-weight-bold">
          {{$t(page+'.Apply to the Waiting List')}}? 
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pt-2 px-8">
          <div>
            {{$t(page+'.Keep me in the list until') +' '+ booking.waitingListTime +' '+ $t(page+'.hours before the booking')}}
            <!--<div class="text-center">{{new Date(booking.date).toLocaleDateString(settings.locale,{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' })}}</div>-->
          </div>
          <div>
            <span>
              <v-slider
                class="mt-16 pt-8"
                color="info"
                :max="Math.min(Math.floor((new Date(booking.date+' '+booking.time+':00')-new Date())/3600000)+1,4)"
                min=1
                step=1
                thumb-label="always"
                ticks="always"
                :thumb-size="50"
                v-model="booking.waitingListTime"
              >        
              </v-slider>
            </span>            
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            @click="dialog_waitingListTime=false"
          >
            <v-icon class="mr-3" >
              mdi-check
            </v-icon>
            {{$t(page+'.Confirm')}}
          </v-btn>
        </v-card-actions>        
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_already_exists"
      width="500"
      content-class="mx-0"
      v-if="existingBookings"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h6 font-weight-bold">
          {{$t(page+'.Duplicate Record')}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_already_exists = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pa-5">
          <v-card class="pa-4  neu-glow">
            <div>
              {{$t(page+'.There is already a reservation on')}} 
              <div class="text-center">{{new Date(booking.date).toLocaleDateString(settings.locale,{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' })}}</div>
            </div>
            <div>{{$t(page+'.for number')}} <div class="text-center font-weight-bold">{{existingBookings[0].phone.toString().replace(/\d{3,4}?(?=...)/g, '$& ')}}</div></div>
            <div>{{$t(page+'.To modify your reservation, please use the link you find in the WhatsApp confirmation message we sent you on')}} </div>
            <div class="text-center">{{new Date(createdDate).toLocaleDateString(settings.locale,{ year: 'numeric', month: 'numeric', day: 'numeric' })}} {{$t(page+'.at')}} {{createdDate.substring(11,19)}}</div>
          </v-card>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_connection_error"
      width="420"
      content-class="neu-glow"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h4 mb-4 font-weight-bold">
          {{$t(page+'.Connection Error')}}
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_connection_error = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{$t(page+'.Close')}}</span>
            </v-tooltip>        
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <div class="text-h6">
            {{$t(page+'.Connection missing or Overloaded')}}:
            <br />
            {{$t(page+'.Please wait few seconds and retry')}}.
            <br><br>
            {{$t(page+'.If problem persist, pls contact Booking service via Whatsapp')}}
          </div>
          <div class="text-center mt-6">
            <v-btn large color="success" :href="'https://wa.me/'+whatsappNumber">
              <v-icon large  class="white--text">mdi-whatsapp</v-icon>
            </v-btn>
            <!--
            <v-btn large color="success" href="https://wa.me/393533300505">
              <a href="https://wa.me/15551234567?text=Voglio%20Prenotare%20per%206%20Persone%20per%20Sabato%20Sera%20alle%2019:00%20Sala%20Interna"></a>
              <v-icon large  class="white--text">mdi-whatsapp</v-icon>
            </v-btn>-->
          </div>

        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_optIn"
      fullscreen
      hide-overlay
      >
      <v-card>
        <v-toolbar dark color="info">
          <v-btn icon dark @click="dialog_optIn=0">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t(page+'.Privacy Policy')}}</v-toolbar-title>
        </v-toolbar>
        <iframe src="/privacy" :height="wHeight" style="width: 100%"></iframe>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_optIn_tos"
      fullscreen
      hide-overlay
    >
      <v-card>
        <v-toolbar dark color="info">
          <v-btn icon dark @click="dialog_optIn_tos=0">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{$t(page+'.Terms of Service')}}</v-toolbar-title>
        </v-toolbar>
        <iframe src="/tos" :height="wHeight" style="width: 100%"></iframe>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.active"
      centered
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { loadScript } from "@paypal/paypal-js";

export default {
  data() {
    return {
      page: "Booking",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      show_newUserMessage:true,
      dialog_warning_before_booking:false,
      dialog_booked:false,
      dialog_error_booked:false,
      dialog_picture:false,
      picture_area:false,
      dialog_connection_error:false,
      dialog_already_exists:false,
      dialog_optIn:false,
      dialog_optIn_tos:false,
      dialog_waitingListTime:false,
      dialog_paypal:false,
      dialog_wa_failed:false,
      dialog_more_than:false,
      loading:false,
      loading_book:false,
      open_confirm_dialog:false,
      loading_verifyNumber:false,
      noProceed_messages:[],
      overbooking:0,
      covers:null,
      paypal:null,
      existingBookings:null,
      existingTime:null,
      freeTables:[],
      createdDate:null,
      continue_message:null,
      date:null,//new Date().toISOString().substring(0,10),
      today:new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000 )).toISOString().split("T")[0],
      slotId:null,
      locationId:null,
      hallId:null,
      time:null,
      area:null,
      newUser:0,
      optIn:0,
      firstName:null,
      lastName:null,
      phone:null,
      countryCode:39,
      remarks:null,
      origin:null,
      locale:null,   
      activeOptions:null,	
      bottom_navigation:1,
      errorPhone:'',
      errorPhone_status:1,
      bookingId:null,
      authenticated:0,
      scrollToTop:false,
      slot:null,
      locations:null,
      tableSplittingMessage:null,
      tablesByCovers:[],
      focus:null,
      requestsCopy:null,
      checkedPhone:null,
      bookingRslt:null,
      bookableDays:null,
      booking:{locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:0,date:null,firstName:null,lastName:null,requests:[],foodStyles:[],phone:null,slotId:null,time:null,optIn:false,gender:null,postalCode:null,waitingListTime:null,WAMessageId:null,waiting:0,childrenPresence:null},
      booking_clone:null,
      slides:[],
      halls:	null,
      requests:[],
      foodStyles:[],
      foodStylesCopy:null,
      faqs:	null,
      menuPicker: null,
      menuBirthdate: false,
      snackbar:{active:false,color:'success',text:''},
      uu:null,
      WAVerification:null,
      WAVerificationStarted:false,
      ppPaid:false,
      ppCancel:false,
      ppError:false,
      paymentRequired:false,
      tryToGetFreeSlots:false,
      slotForPaypal:null,
      WAStatusCode:null,
      WAStatus:null,
      customerId:null,
      successfulBooking:false,
      forceTableAllocation:false,
      expired:null,
      VMVerification:false,
      //environment:'sandbox',
      mobilePhoneRegex:null,
      checkingWADelivered:0,
      bookingId:null,
      resendMessageEnabled:true,
      WADelivered:0,
      voxNumber:false,
      bookingId_WA:null,
      //sb Platform 2290192117028630441
      paypal_old_client_id:{"sandbox":"Ad8b15yl_SCAbExg9_80GCAFgkzQgoYF1hWemg4q6BAsZIHzQX9xUGz6y2urh9EdkS46Iz9SSv8VrZzo","production":"AcjCYu0UHz5EzxfKfkK3r8HUB43M_ie6uddGR1WT-aDwEddeOQ3pMAm4mPP-bOFsR1cGXqSWZUHRQusp"},
    };
  },
  created(){
    //this.$vuetify.theme.dark=true;
    //localStorage.removeItem('uu');
    sessionStorage.removeItem('jwt');
    sessionStorage.removeItem('settings');
  
    var la=window.navigator.userLanguage||window.navigator.language;
    console.log(2018,la)
    //la="jp-JP";
    this.settings.locale=la;
    this.locale=la;
    console.log(2020,la,this.settings)
    this.$store.dispatch("setLocale",la.substring(0,2));
    
    this.booking.origin=this.$route.path?this.$route.path:'/db';
    this.bookingId=this.$route.query.p;
    if (this.$route.query&&this.$route.query.q)
    {
      console.log(2143,this.$route.query.q)
      //this.customerId=this.$route.query.q.split('/?')[0];
      this.sessionId=this.$route.query.q.split('/?')[0];
      console.log(this.customerId)
    }
    else{
      this.customerId=null;
    }
    //console.log(2104,this.customerId)
    //console.log(819,window.location.href);

    //this.isDarkMod=new Date().getHours()>8&&new Date().getHours()<17?false:true;
    this.isDarkMod=true;
    //console.log(830,this.settings);
    this.Authenticate();
    //this.paypalSetup();
  },  
  mounted: function () {

  },
  computed : {
    ...mapGetters(["settings","countries"]),
    isDarkMod: {
      get()
      {
        //console.log(1697,this.dark);
        return this.dark;
      },
      set(value)
      {
        //console.log(1702,this.dark);
        this.$vuetify.theme.dark = value;
        this.$store.dispatch("scheme/setDarkTheme", value);
      }
    },
    tableSplittingAlert: function()
    {
      if (this.booking.locationId)
      {
        var limits=this.locations.find(l=>l.locationId==this.booking.locationId);
        //console.log(806,limits,this.booking.covers,this.booking.children)
        if ((limits.splitFrom&&this.booking.covers/1+this.booking.children/1) > limits.splitFrom)
        {
          this.tableSplittingMessage=this.settings.options.splitMessage;
        }
        else if ((limits.splitFrom&&this.booking.covers/1+this.booking.children/1) > limits.splitPossibleFrom)
        {
          this.tableSplittingMessage=this.settings.options.splitPossibleMessage;
        }
        else
        {
          this.tableSplittingMessage='';
        }
      }
      //console.log(1643,this.tableSplittingMessage)
      return this.tableSplittingMessage?true:false;
    },
    warningMessage: function()
    {
      var duration='';
      var delayShow='';
      var warningMsg='';
      var k=this.freeTables.find(f=>f.slotId==this.booking.slotId)
      //console.log(1112,k,this.booking.slotId) 
      if(this.settings.options.showBookingDurationInWarning=='1'&&k.showBookingDuration)
      {
        //console.log(1108,this.locations,this.booking,this.freeTables)
        //var k=this.locations.map(e => {return {covers:e.covers.find(c => c.slotId === this.booking.slotId)}})[0].covers
        //var k=this.locations.find(k=>k.locationId===this.booking.locationId).covers.find(c=>c.slotId===this.booking.slotId)
        duration= this.$t(this.page+'.Your table is reserved from')+' '+ k.name+' ' + this.$t(this.page+'.to')+' '+ parseInt( k.endTime/3600)+':'+ parseInt( k.endTime%3600/60);
      }
      if (this.settings.options.showAcceptedDelayinWarning=='1'&&k.showAcceptedBookingDelay)
      {
        var delay1=parseInt(this.settings.options.acceptedDelay)
        var delay2=parseInt( k.startTime)+delay1*60;
        var delay3=parseInt( delay2/3600)+':'+ ('00'+String( delay2%3600/60)).slice(-2);
        ////console.log(1497,delay1,delay2,delay3)
        delayShow=this.$t(this.page+'.Your table is guaranteed until') +' '+delay3;
      }
      if (this.settings.options.warningBeforeBookingMessage)
      {
        warningMsg='<p>'+this.settings.options.warningBeforeBookingMessage+'</p>';
      }

      return warningMsg+(duration?'<p>'+duration+'</p>':'')+(delayShow?'<p>'+delayShow+'</p>':'')
    },
    continue_button:function()
    {
      var O=this.settings.options;
      
      var p0=this.booking.optIn;
      var p1=this.booking.date;
      var p2=this.booking.covers;
      var p3=this.booking.slotId;
      var p4=this.booking.locationId;
      var p5=this.booking.lastName;
      var p6=this.booking.phone;
            var pD=(O.childrenPresenceRequired=='1'&&this.booking.childrenPresence!=null||O.childrenPresenceRequired=='0');
      var p7=(this.booking.phone&&(this.booking.phone.length==9||this.booking.phone.length==10));
      var p8=(O.emailRequired=='1'&&this.booking.email||O.emailRequired=='0')
      var p9=((O.minAge||O.birthdateRequired=='1')&&this.booking.birthdate||O.birthdateRequired=='0'&&!O.minAge)
      var pA=(O.postalCodeRequired=='1'&&this.booking.postalCode&&this.booking.postalCode.length==5&&this.booking.countryCode=='39'||O.postalCodeRequired=='0'||this.booking.countryCode!='39')
      var pB=((this.paymentRequired&&this.ppPaid||!this.paymentRequired)&&this.settings.options.showWarningBeforeBooking=='0')
      var pC=this.booking.firstName||this.booking.bookingId;
      var p90=!(p1&&p2&&p3&&p4&&p5&&p6&&p7&&p8&&p9&&pA&&pC&&pD);
      
      var Tcover={'ref':'covers','btn':this.$t(this.page+'.Covers Missing')};
      var Ttime={'ref':'time','btn':this.$t(this.page+'.Time Missing')};
      var Tarea={'ref':'area','btn':this.$t(this.page+'.Area Missing')};
      var Tname={'ref':'lastName','btn':this.$t(this.page+'.LastName Missing')};
      var Tfname={'ref':'firstName','btn':this.$t(this.page+'.FirstName Missing')};
      var Tphone={'ref':'phone','btn':this.$t(this.page+'.Phone Missing')};
      var Temail={'ref':'email','btn':this.$t(this.page+'.Email Missing')};
      var Tbirth={'ref':'birthdate','btn':this.$t(this.page+'.Birthdate Missing')};
      var Tzip={'ref':'postalCode','btn':this.$t(this.page+'.Postal Code Missing')};
      var Tpay={'ref':'prepayment','btn':this.$t(this.page+'.Prepayment Missing')};
      var TCP={'ref':'childrenPresence','btn':this.$t(this.page+'.ChildrenPresence Missing')};
      //var ToptIn=this.$t(this.page+'.T&C Missing');

      this.focus=null;
      this.noProceed_messages=[];
      //if (!p0)   {this.noProceed_messages.push(ToptIn);this.focus='optIn'};
      if (!p2)   {this.noProceed_messages.push(Tcover)}
      if (!p3)   {this.noProceed_messages.push(Ttime)}
      if (!p4)   {this.noProceed_messages.push(Tarea)}
      if (!p5)   {this.noProceed_messages.push(Tname)}
      if (!pC)   {this.noProceed_messages.push(Tfname)}
      if (!p7)   {this.noProceed_messages.push(Tphone);this.focus='phone'}
      if (!p8)   {this.noProceed_messages.push(Temail)}
      if (!p9)   {this.noProceed_messages.push(Tbirth)}
      if (!pA)   {this.noProceed_messages.push(Tzip)}
      if (!pD)   {this.noProceed_messages.push(TCP)}
      
      //if (!pB)   {this.noProceed_messages.push(Tpay)}
      //console.log(2213,this.noProceed_messages);
      return p90;
    }
  },
  watch : {
    menuBirthdate (val) {
      val && setTimeout(() => (this.$refs.birthdate.activePicker = 'YEAR'))
    },
    'booking.date':function(newValue,oldValue)
    {
      //console.log(1605,newValue,oldValue)
      //this.successfulBooking=false;
      this.booking.waitingListTime=null;
      this.booking.waiting=0;
      this.booking.slotId=null;
      if (this.authenticated==1&&this.booking.mealId)
      {
        this.getFreeSlots(this.booking);
      }
    },
    'booking.covers':function(newValue)
    {
      this.booking.slotId=null;
      //console.log(1774,this.booking.waitingListTime)
      this.booking.waitingListTime=null;
      this.booking.waiting=0;
      //console.log(1776,this.booking.waitingListTime)
      if (this.authenticated==1&&this.booking.mealId)
      {
        this.getFreeSlots(this.booking);
      }
    },
    'booking.children':function(newValue)
    {
      this.booking.slotId=null;
      //console.log(1785,this.booking.waitingListTime)
      this.booking.waitingListTime=null;
      this.booking.waiting=0;
      //console.log(1787,this.booking.waitingListTime)
      if (this.authenticated==1&&this.booking.mealId)
      {
        this.getFreeSlots(this.booking);
      }
    },    
    'booking.locationId':function(newValue)
    {
      this.booking.slotId=null;
      //console.log(1796,this.booking.waitingListTime)
      this.booking.waitingListTime=null;
      this.booking.waiting=0;
      //console.log(1798,this.booking.waitingListTime)
      //console.log(1799,this.booking.mealId,this.authenticated,this.booking.waitingListTime)
      //console.log(1800,this.authenticated==1&&this.booking.mealId)
      if ((this.authenticated==1||this.meals.length==1)&&this.booking.mealId)
      {
        //console.log(1803,this.booking)
        this.getFreeSlots(this.booking);
      }
    },
    'booking.mealId':function(newValue)
    {
      this.booking.slotId=null;
      console.log(2307,this.booking)
      this.booking.waitingListTime=null;
      this.booking.waiting=0;
      //console.log(1812,this.booking.waitingListTime)
      if(newValue)
      {
        console.log(2313,this.booking,newValue)
        this.getFreeSlots(this.booking);
      }      
    },
    'booking.countryCode': function(newValue,oldValue)
    {
      console.log(2319,newValue,oldValue)
      if(!this.voxNumber)
      {
        //this.booking.phone='';
      }
    }, 
    'booking.phone': function(newValue,oldValue)
    {
      //console.log(2426,newValue,oldValue)
      //this.booking.phone=newValue.replace(/[^0-9]+/g, '');
    },     
  },
  methods:
  { 
    async resendWA(bookingId)
    {
      const payload=JSON.stringify({"action":"booking_resendWAPolicy","payload":{"bookingId":bookingId}});
      console.log(2337,bookingId);
      const res = await this.$http.post('/booking/booking.php', payload );
      //console.log(1026,res);
      this.loading_optOut=false;
      switch (res.data.errorid)
      {
        case '0':
          this.snackbar.text=this.$t(this.page+'.'+res.data.message);
          this.snackbar.color='success';
          this.snackbar.active=true;
          this.resendMessageEnabled=false
        break;
        case '0006':
          this.$router.push('/unknown').catch(() => {});
        break;        
      }
    },    
    async changeNumber(bookingId,phoneChanged,countryCode)
    {
      const payload=JSON.stringify({"action":"booking_wrongNumber","payload":{"bookingId":bookingId,"phone":phoneChanged,"countryCode":countryCode}});
      console.log(2355,payload);
      const res = await this.$http.post('/booking/booking.php', payload );
      //console.log(1026,res);
      this.loading_optOut=false;
      switch (res.data.errorid)
      {
        case '0':
          this.snackbar.text=this.$t(this.page+'.'+res.data.message);
          this.snackbar.color='success';
          this.snackbar.active=true;
          this.resendMessageEnabled=false
        break;
        case '0006':
          this.$router.push('/unknown').catch(() => {});
        break;        
      }
    },    

    phoneRegexHints(countryCode)
    {
      //console.log(2460,countryCode)
      var output='';
      if (countryCode && this.mobilePhoneRegex)
      {
        output='Check twice the number: if it is wrong we have no way to contact you';
        var dtls=this.mobilePhoneRegex.find(m=>m.countryCode==countryCode)
        
        if (dtls)
        {
          switch (countryCode)
          {
            case 39:
              output='Inizia per '+dtls.startsWith;
              if(dtls.minLength==dtls.maxLength)
              {
                output+=' | '+dtls.maxLength + ' cifre';
              }
              else
              {
                output+=' | Da '+dtls.minLength +' a '+dtls.maxLength + ' cifre';
              }
            break;
            default:
              output='Starts with '+dtls.startsWith;
              if(dtls.minLength==dtls.maxLength)
              {
                output+=' | '+dtls.maxLength + ' digits';
              }
              else
              {
                output+=' | '+dtls.minLength + ' or '+dtls.maxLength + ' digits';
              }
          }
        }
      }
      return output;
    },
    is_ValidPhone(v,r) {
            //var p='^324[0-9]{6}$'
            //var p='^6[6|9|7|5|8|9][0-9]{6,7}$'
            if (v)
            {
              const vr=this.mobilePhoneRegex.find(c=>c.countryCode==r)?this.mobilePhoneRegex.find(c=>c.countryCode==r).mobileNumberRegex:null
              const p=vr?vr.replace('\\d','[0-9]'):''
              const pattern = new RegExp(p);
              //return pattern.test(v) || (r==39?'Ricontrolla: il formato sembra non corretto':'Please, check: this seems an invalid number')
              const ww= pattern.test(v) || this.phoneRegexHints(r)
              console.log(2335,ww)
              return ww;
            }
            else
            {
              return false;
            }
          },
    activeMeals()
    {
      var currentDate=this.bookableDays.find(d=>d.date==this.booking.date)
      if (currentDate)
      {
        var aMeals=this.meals.filter(m=>(m.meal==='lunch'||m.meal==='breakfast')&&currentDate.isLUNCH_OPEN||(m.meal==='dinner'||m.meal==='cocktail')&&currentDate.isDINNER_OPEN)
        //console.log(2327,aMeals);
        return aMeals;
      }
      else
      {
        var aaMeals=[];
        return aaMeals;
      }
    },
    /*
    async checkPhoneNumber()
    {
      //console.log(1009,this.booking.date);
      var customerId=localStorage.getItem('customerId');
      this.loading=true;
      try{
          const payload=JSON.stringify({"action":"checkPhoneNumber_DB","payload":{"phone": this.booking.phone,"countryCode":this.booking.countryCode,"firstName":this.booking.firstName,"lastName":this.booking.lastName,"customerId":customerId}});
          const res = await this.$http.post('/booking/booking.php', payload );
          this.loading= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                
                //console.log(1064,res)
                this.WAVerification=true;//res.data.payloads.summary.Visite?true:false;
                //this.checkedPhone=res.data.payloads.summary.Visite?true:false;
                this.booking.firstName=res.data.payloads.firstName
                this.booking.lastName=res.data.payloads.lastName
                this.booking.fullName=res.data.payloads.fullName
                this.booking.phone=res.data.payloads.phone
                this.booking.countryCode=res.data.payloads.countryCode
                this.booking.newsletter=res.data.payloads.newsletter?true:false;
                this.WAVerification=res.data.payloads.WAVerification;
                //console.log(1068,this.checkedPhone,this.booking)
                //this.saveToLocalStorage();
                //return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              //console.log(1893, res.data)
          }  
      } catch(e)
      {
        //this.loading= false;
      }
    },
    */
    retryBtn: function () 
    {
      //console.log("379");
      this.$refs.paypal_div='';
      this.dialog_paypal = false;
      this.ppError = false;
      this.ppCancel = false;     
      //this.setLoaded(this.booking,100);
    },
    noRetryBtn: function () 
    {
      //console.log("379");
      this.dialog_paypal = false;
      this.ppError = false;
      this.ppCancel = false;
      this.$refs.paypal_div='';
      this.dialog_paypal=false
      //this.setLoaded(20);
    },
    async setLoaded (slot,ta)
    {
      this.ppLoaded = true;
      this.dialog_paypal = false;
      //console.log(1827,slot,this.booking,this.booking.slotId)
      //console.log(1828,this.freeTables)
      //console.log(1829,this.freeTables.find(t=>t.slotId==slot.slotId))
      //console.log(1830,this.freeTables.find(t=>t.slotId==slot.slotId).prepayment)
      //console.log(1831,this.booking.covers)
      ////console.log(1832,(parseFloat(this.freeTables.find(t=>t.slotId==slot.slotId).prepayment)*parseInt(this.booking.covers)).toFixed(2))
      var amount=this.booking.prepaidAmount;//'50.00'
      var description='Cauzione per ' + this.booking.covers +' Ospiti';
      var brand=this.settings.brand;
      var paypalIntent=this.settings.options.paypalIntent
      //console.log(1835,amount,description)
      var referenceId=this.utf8_to_b64(this.booking.date+'|'+this.booking.covers+'|'+this.booking.phone);
      //var brand=this.settings.brand;
      //https://developer.paypal.com/sdk/js/reference/
      //https://developer.paypal.com/docs/api/orders/v2/#orders_create
      //https://www.paypal-community.com/t5/Payments-Archives/How-does-the-quot-Honor-Period-quot-for-authorizations/m-p/2773046
      //https://paypal.github.io/PayPal-PHP-SDK/sample/doc/payments/Reauthorization.html
      var opts={
              style: {
                layout: "vertical",
                color: "blue",
                shape: "rect",
                label: "pay"
              },
              createOrder: function(data, actions) 
              {
                return actions.order.create(
                {
                  "purchase_units": 
                  [{
                    "reference_id": referenceId,
                    "description": description,
                    "amount": {
                      "currency_code": "EUR",
                      "value": amount
                    }
                  }],
                  "intent":paypalIntent,
                  "application_context":
                  {
                    "brand_name": brand,
                    "shipping_preference": "NO_SHIPPING"
                  }   
                });
              },
            /*
            createSubscription: (data, actions) => {
              if (this.settings.subscription_id) 
              {
                //console.log('shop_644',this.user.subscription_id,this.selected_plan.plan_id);
                
                if (this.user.subscription_status=='SUSPENDED')
                {
                  return actions.subscription.activate(this.user.subscription_id, {
                    reason: "Reactivated by customer"
                  });
                }
                else
                {  
                  return actions.subscription.revise(this.user.subscription_id, {
                    plan_id: this.selected_plan.plan_id
                  });
                }
              }
              else 
              {
                return actions.subscription.create({
                  plan_id: this.selected_plan.plan_id,
                  start_time: this.user.subscription_start,
                });
              }
            },
            //3421575838
            */
            onApprove: async (data, actions) => {
              //console.log(1788, data,actions);
              //console.log(1886,data.orderId)
              
              //this.booking.prepaidAmount=amount;
              this.ppPaid=true;
              this.dialog_paypal=true;
              //console.log(1889,this.booking)
              if (data.orderID) {
                //this.$store.dispatch("setCredits",this.user.credits);
                //update database
                this.booking.payPalOrderId=data.orderID,
                data.bookingDate=this.booking.date;
                data.lastName=this.booking.lastName;
                data.customerId=this.booking.customerId;
                data.phone=this.booking.countryCode+this.booking.phone;
                data.amount=amount;
                data.paypalIntent=this.settings.options.paypalIntent
                this.savePayPalPayment(data);
              }
            },
            onCancel: (data) => {
              this.ppCancel = true;
              this.dialog_paypal=true;
              //console.log("ppcancel", data);
            },
            onError: (err) => {
              //console.log("error", err);
              this.dialog_paypal=true
              //let err_details=err.details;
              //this.error_message='Error: '+err_details.description;
              ////console.log(this.error_message);
              let err_string=JSON.stringify(err);
              //console.log(1802,err_string);
              ////console.log(err.substr(0,30))
              //console.log("erore:", err);
              this.ppError = true;

              //console.log(1809,err.details.description);
            },
          };
      //console.log(1916, this.ppLoaded,this.settings.options.paypalClientId);
      
      //this.settings.options.paypalClientId='AT10NA2W3fWWn5y2UB1qX3GVnTFD8ePH9bry9D-sagmcX_4VY8SxfFA21Nri7FKpbxCQb02aGVrYnZFa';
      this.paypal = await loadScript({ "client-id": this.settings.options.paypalClientId, "currency": "EUR","disable-funding":"credit","intent":this.settings.options.paypalIntent.toLowerCase()});
      if (paypal) {
          try {
              await this.paypal.Buttons(opts).render(this.$refs.paypal_div);
          } catch (error) {
              console.error("failed to render the PayPal Buttons:", error);
          }
      }
    },
    async savePayPalPayment(data)
    {
      //console.log(1949, data);
      try {
        const payload=JSON.stringify({"action":"PayPalPayment_set","payload":data});
        const res = await this.$http.post('/shop/shop.php', payload );
        //console.log(1953,payload);
        let pl=res.data.payload;
        switch (res.data.errorid) {
          case "0":
            //console.log("467", data);
            //console.log("468", res.data);
            this.ppPaid = true;
            setTimeout(() => {
              //this.process();
              this.saveBooking()
            }, 1000);
            /*
            this.user.plan_name=pl.name;
            this.user.planlevel=pl.planlevel
            this.user.next_billing_time=pl.next_billing_time;
            this.user.missinginvoicedata=0*/
            break;
          case "0007":
            this.$router.push("/auth/login").catch(() => {});
            break;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    }, /*       
    hasPrepayment()
    {
      //console.log(1526,this.booking.slotId);
      //console.log(1527,this.freeTables)
      if (this.booking.slotId&&this.freeTables)
      {
        let k= this.freeTables.filter(t=>t.slotId==this.booking.slotId)
        //console.log(1531,k)
        let z= this.freeTables.find(t=>t.slotId==this.booking.slotId).prepayment
        this.setLoaded(100);
        //console.log(1533,z)
      }

    },*/
    isOlder(da, y) {
      //console.log(2333,da,y);
      var z=false;
      if (da)
      {
        var d=new Date(da)
        d.setFullYear(d.getFullYear() + y/1);
        //console.log(1851,d,'|',new Date());
        //console.log(1852,d<new Date());
        z=d<new Date();
        //console.log(1854,z);
      }
      //this.ageVerified=z;
      ////console.log(1858,this.ageVerified);
      return z;
    },    
    changeGender()
    {
      //console.log(1378,this.booking.gender);
      this.settings.avatar=this.booking.gender;
      this.$store.dispatch("setAvatar",this.booking.gender);
    },
    saveBirthdate (date) {
      this.$refs.menuBirthdate.save(date)
    },    
    subtractYears(years) {
      var date = new Date(Date.now())
      date.setFullYear(date.getFullYear() - years);
      return date.toISOString().substring(0, 10);
    },    
    processSlot(i)
    {
      this.booking.slotId=null;
      this.booking.time=i.name;
      var id=this.utf8_to_b64(this.booking.phone+Date.now());
      //console.log(2302,i,id,this.booking.waitingListTime,this.booking.waiting);
      //delete this.booking.waitingListTime;
      //this.booking.waitingListTime=null
      //console.log(2305,i,id,this.booking.waitingListTime);
      this.slotForPaypal=i;
      ////console.log(2088,i.prepayment,this.user.arrivedCount,this.user.noshowCount,this.user.noShowYeld,this.bookableDays.find(d=>d.date==this.booking.date))
      //console.log(2089,i.prepayment)                                                                                         //10
      //console.log(2090,(this.booking.covers+this.booking.children)>=this.settings.options.depositMinCovers)                   //6
      //console.log(2091,this.customer.arrivedCount,this.settings.options.depositOnlyCustomersWithLessThanBooking)
      //console.log(2092,this.customer.arrivedCount<parseInt(this.settings.options.depositOnlyCustomersWithLessThanBooking))  
      //console.log(2093,this.customer.noShowYeld,this.settings.options.depositOnlyCustomersWithLessThanNoShow)        //21
      //console.log(2094,this.customer.noShowYeld>parseInt(this.settings.options.depositOnlyCustomersWithLessThanNoShow))           //33
      //console.log(2095,this.bookableDays.find(d=>d.date==this.booking.date).overrideDepositRules==1)
      var deposit=i.prepayment;
      var forcedDeposit=this.bookableDays.find(d=>d.date==this.booking.date).deposit;
      //console.log(2382,i.prepayment,deposit,forcedDeposit,this.settings.options.depositMinCovers,this.customer.arrivedCount,this.settings.options.depositOnlyCustomersWithLessThanBooking,this.customer.noShowYeld,this.settings.options.depositOnlyCustomersWithLessThanNoShow)
      
      if ((i.prepayment&&(
                          (this.booking.covers+this.booking.children)>=this.settings.options.depositMinCovers
                          &&(
                            this.customer.arrivedCount<parseInt(this.settings.options.depositOnlyCustomersWithLessThanBooking)||this.customer.noShowYeld>parseInt(this.settings.options.depositOnlyCustomersWithLessThanNoShow)
                          )
                         ))||forcedDeposit//this.bookableDays.find(d=>d.date==this.booking.date).deposit
      )
      {
          this.paymentRequired=true;
          this.booking.forcedDeposit=forcedDeposit;
          this.booking.deposit=forcedDeposit?forcedDeposit:deposit;
          //console.log(2109,i,deposit,forcedDeposit,parseInt(this.booking.covers))
          var amount=((forcedDeposit?forcedDeposit:deposit)*parseInt(this.booking.covers)).toFixed(2)
          this.booking.prepaidAmount=amount;//((forcedDeposit?forcedDeposit:depositthis.bookableDays.find(d=>d.date==this.booking.date).deposit?this.bookableDays.find(d=>d.date==this.booking.date).deposit:i.prepayment)*parseInt(this.booking.covers)).toFixed(2)
          //console.log(2112,this.booking.prepaidAmount)
          if (this.settings.options.showWarningBeforeBooking=='0')
          {
            this.setLoaded(i,20);
          }
      }
      else
      {
        this.paymentRequired=false
        this.booking.prepaidAmount=null
      }
      this.booking.waiting=0;
      if ((!i.assigned&&i.unassigned||i.totalCovers>i.covers)&&this.settings.options.manageWaitingList==1&&!this.booking.slotId)
      {
        this.booking.waiting=1;
        this.dialog_waitingListTime=true;
      }
    },
    utf8_to_b64(str) {
      return window.btoa(encodeURIComponent(str));
    },
    async optOut()
    {
      this.loading_optOut=true;
      //console.log(2216,this.customerId);
      this.customerId=localStorage.getItem('customerId')
      const payload=JSON.stringify({"action":"optOut","payload":{"customerId":this.customerId}});
      const res = await this.$http.post('/booking/booking.php', payload );
      //console.log(1026,res);
      this.loading_optOut=false;
      switch (res.data.errorid)
      {
        case '0':
          localStorage.removeItem('customerId');
          this.snackbar.text=this.$t(this.page+'.'+res.data.message);
          this.snackbar.color='success';
          this.snackbar.active=true;
          await this.delay(1000);
          //console.log(2373)
          this.Authenticate();
          //console.log(2375);
        break;
        case '0006':
          this.$router.push('/unknown').catch(() => {});
        break;        
      }
    },
    delay(milliseconds){
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        });
    },     
    removeUser(action)
    {
      //console.log(1073);
      this.WAVerification=false;
      //console.log(2391,this.WAVerification)
      this.booking.phone=null;
      this.booking.firstName=null;
      this.booking.lastName=null;
      if(action==1)
        localStorage.removeItem('customerId');
    },
    disabledSlot(s,s1)
    {
      ////console.log(1667,s,s1,this.booking.covers,this.tablesByCovers)
      var covers=this.booking.covers/1+this.booking.children/1
      var requiredTables=this.tablesByCovers.find(t=>t.covers==covers).tables;
      var availableCovers=(s.totCovers-s.usedCovers)/1+this.overbooking/1;
      var zk=this.locations.find(l => l.locationId==this.booking.locationId).tables[s1].availableTables/1+this.overbooking/1
      var k=covers>availableCovers||!this.booking.mealId||requiredTables>zk;
      //var z=this.booking.covers>((s.totCovers-s.usedCovers)/1+this.overbooking/1)||!this.booking.mealId||this.tablesByCovers.find(t=>t.covers==covers).tables>this.locations.find(l => l.locationId==this.booking.locationId).tables[s1].availableTables/1+this.overbooking/1
      ////console.log(1635,s,k,this.booking,this.locations)
      //this.isWaitingList=k;
      return k;
    }, 
    locationDescription(l)
    {
      if (!this.booking.slotId)
      {
        return l.nameDB;//location.name
      }
      else
      {
        //var z=l.tables.find(t=>t.slotId==this.booking.slotId)
        //return l.name+'<br># ' + (z.availableTables-z.usedTables) +'/'+ z.availableTables;
        return l.nameDB;        
      }
    },    
    onScroll(e)
    {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.scrollToTop = top > 20
    },
    toTop()
    {
      this.$vuetify.goTo(0)
    },
    async Authenticate()
    {
      this.loading=true;
      this.customerId=localStorage.getItem('customerId');
      //this.customerId=this.customerId??localStorage.getItem('customerId');
      var hostname=window.location.hostname;

      //console.log(2418,this.date,this.today,window.location.hostname)
      //try{
          const payload=JSON.stringify({"action":"Authenticate","payload":{"customerId":this.customerId,"bookingId":this.bookingId,"hostname":hostname,"locale":this.settings.locale,"sessionId":this.sessionId}});
          const res = await this.$http.post('/booking/booking.php', payload );
          //console.log(2422,res);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              sessionStorage.setItem('settings', JSON.stringify(res.data.payloads.settings));
              ////console.log(966,document.link)
              document.title = res.data.payloads.settings.brand;
              var locale=this.settings.locale;
              //document.querySelector("link[rel*='icon']").href = this.settings.favicon?'/favicons/'+this.settings.favicon:"/favicon.ico";
              this.$store.dispatch("setSettings",res.data.payloads.settings);
              //this.$store.dispatch("setLocale",locale);
              this.customer=res.data.payloads.customer;
              //this.isDarkMod=res.data.payloads.customer.dark;
              //console.log(2433,res.data.payloads.customer)
              if (this.customer&&this.customer.customerId)
              {
                localStorage.setItem('customerId',this.customer.customerId);
              }
              this.expired=res.data.payloads.expired;
              //console.log(2716,this.expired.expired)
              this.faqs=res.data.payloads.faqs??null;
              this.requests=res.data.payloads.requests||[];
              this.requestsCopy=JSON.stringify(this.requests);
              this.foodStyles=res.data.payloads.foodStyles||[];
              this.foodStylesCopy=JSON.stringify(this.foodStyles);
              this.meals=res.data.payloads.meals??null;
              this.booking.date=res.data.payloads.bookableDays[0].date;
              this.mobilePhoneRegex=res.data.payloads.mobilePhoneRegex;
              //console.log(2442,this.meals)
              this.settings.locale=res.data.payloads.settings.locale;
              console.log(2804,this.settings.locale)
              if(this.meals.length==1)
              {
                this.booking.mealId=this.meals[0].mealId;
                console.log(2884,this.booking)
              }
              this.locations=res.data.payloads.locations??null;
              if (this.locations.length==1)
              {
                this.booking.locationId=this.locations[0].locationId;
              }
              this.bookableDays=res.data.payloads.bookableDays;
              //this.tablesByCovers=res.data.payloads.tablesByCovers??null;
              
              if(res.data.payloads.currentBooking)
              {
                this.booking=res.data.payloads.currentBooking;
                this.booking.optIn=true;
                this.WAVerification=true;

                this.requests=res.data.payloads.requests||[];
                this.foodStyles=res.data.payloads.foodStyles|| [];                
                this.booking.newsletter=res.data.payloads.newsletter;
                //this.WAVerification=true;
                //console.log(2460,this.WAVerification)
                this.settings.avatar=this.booking.gender;
                //this.$store.dispatch("setAvatar",this.booking.gender);                
              }
              else
              {
                if (this.customer)
                {
                  //console.log(2468,JSON.stringify(this.booking))
                  Object.assign(this.booking, this.customer);
                  //console.log(2470,this.customer,this.booking);
                  //console.log(2471,JSON.stringify(this.booking))
                  this.booking.firstName=this.customer.firstName;
                  this.booking.lastName=this.customer.lastName;
                  this.settings.avatar=this.customer.gender;
                  this.WAVerification=this.customer.WASent;
                  //console.log(2474,this.WAVerification)
                  this.booking.birthdate=this.customer.birthdate;
                  if(this.customer.gender)
                  {
                    //this.$store.dispatch("setAvatar",this.customer.gender);
                  }
                }                
                this.requests=res.data.payloads.requests||[];
                this.foodStyles=res.data.payloads.foodStyles|| [];
                this.booking_clone={...this.booking};

              }

              if (res.data.payloads.voxPhoneNumber)
              {
                this.booking.phone=res.data.payloads.voxPhoneNumber.phone;
                this.booking.countryCode=res.data.payloads.voxPhoneNumber.countryCode;
                this.VMVerification=true;
                this.voxNumber=true;
              }
              //this.booking.requests=res.data.payloads.requests||[];

              //console.log(2488,this.faqs,this.requests,this.booking,this.booking.requests,this.customer);
              
            break;
            case '0006':
              this.$router.push('/unknown').catch(() => {});
            break;
          }
          this.loading= false;
      /*} catch(e)
      {
          this.dialog_connection_error=true;
          console.error(1215,e);
      }*/
    },    
    async verifyForWA()
    {
      //console.log(1009,this.booking.date);
      this.loading_verifyNumber=true;
      try
      {
        var b=this.booking;
        const payload=JSON.stringify({"action":"Booking_verifyForWA_get","payload":{"phone": b.phone,"firstName":b.firstName,"lastName":b.lastName,"countryCode":b.countryCode,"birthdate":b.birthdate}});
        const res = await this.$http.post('/booking/booking.php', payload );
        //console.log(1164,res)
        this.loading_verifyNumber= false;
        switch (res.data.errorid)
        {
          case '0':
              //this.saveToLocalStorage();               
              sessionStorage.setItem('jwt', res.data.jwt);
              this.booking.WAMessageId=res.data.rslt.messages[0].id;
              this.booking.customerId=res.data.customerId;
              this.WAVerificationStarted=true;
              //console.log(1068,this.checkedPhone,this.booking)
              this.snackbar.active=true;
              this.snackbar.color='success';
              this.snackbar.text=this.$t(this.page+'.WhatsApp Business Request Sent')
          break;
          case '0001':
              //console.log(2334);
              this.WAVerification=false;
              //console.log(2444,this.WAVerification)
              this.snackbar.active=true;
              this.snackbar.color='error';
              this.snackbar.text=this.$t(this.page+'.WhatsApp Business: Error sending message')
          break;
          case '0007':
            //console.log(2342);
            var responsePayload=JSON.parse(res.data.payload)
            this.errorTitle=responsePayload.errorInfo[2];
            this.errorMessage=responsePayload.xdebug_message;
            //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
            this.dialog_connectionError=true;
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
          default:
              //console.log(2353);
          }  
      } catch(e)
      {
        //this.loading= false;
      }
    },
    saveToLocalStorage()
    {
      if (this.booking.phone&&this.booking.lastName&&this.booking.firstName)
      {
        //console.log(2375,this.booking)
        var uu=this.b64E(JSON.stringify({"phone":this.booking.phone,"lastName":this.booking.lastName,"firstName":this.booking.firstName}))
        //localStorage.setItem('uu', uu);
      }  
    },
    async WAStatusCheck()
    {
      //console.log(2615,this.booking,this.booking.WAMessageId, this.customerId,this.booking.customerId)
      ////console.log(974,this.date,this.slotId,this.locationiId)
      this.loading_book=true;
      var customerId=localStorage.getItem('customerId');
      let payload={"action":'WAStatusCheck',"payload":JSON.stringify({"phone":this.booking.phone,"countryCode":this.booking.countryCode,"WAMessageId":this.booking.WAMessageId,"customerId":customerId})}
      let rsp= await this.updateDB(payload);
      //console.log(2620,rsp)
      this.loading_book=false;
      switch (rsp.errorid)
      {
        case '0':
          var pl=rsp.payloads;
          this.WAStatusCode=pl.statusCode;
          this.booking.currentTime=pl.currentTime;
          this.booking.WAStatusCode=pl.statusCode
          this.WAVerification= (pl.statusCode>16&&this.settings.options.WA_ResponseRequired=='1')
                                ||(pl.statusCode>4&&this.settings.options.phoneNumberVerificationRequired=='1'
                                ||pl.statusCode>=4&&this.settings.options.phoneNumberVerificationRequired=='0')?true:false
          //console.log(2630,this.WAStatusCode,this.WAVerification);
        break;
      }
      //console.log(2655,this.WAStatusCode)
    },    
    async getFreeSlots()
    {
      if (!this.WAVerification&&this.settings.options.phoneNumberVerificationRequired=='1')
      {
        this.WAStatusCheck()
      }
      this.tryToGetFreeSlots=false;
      this.dialog_connectionError=false;  

      if(this.booking.covers&&this.booking.locationId&&this.booking.mealId&&this.booking.date)
      { 
        try{
          this.authenticated=1;
          ////console.log(1109,this.booking.date);
          let booking={...this.booking};
          delete booking.requests;
          delete booking.foodStyles
          ////console.log(1112,this.booking);
          booking.reassign=0;
          booking.requester='db';
          this.loading=true;

            const payload=JSON.stringify({"payload": booking,"action":"freeTables_map_get"});
            const res = await this.$http.post('/booking/booking.php', payload );
            //console.log(1811,res, new Date());
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0':
                  this.tryToGetFreeSlots=true;
                  sessionStorage.setItem('jwt', res.data.jwt);
                  this.freeTables=res.data.payloads.freeTables;
                  this.forceTableAllocation=res.data.payloads.forceTableAllocation;
                  //this.allRules=res.data.payloads.allRules;
                  //console.log(2061,this.freeTables,this.allRules)
                  return true;
              break;
              case '0003':
                  this.freeTables=[];
                  this.tryToGetFreeSlots=true;
                  this.snackbar.text=res.data.message;
                  this.snackbar.color='warning';
                  this.snackbar.active=true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }
      }
      else
      {
        this.freeTables=[];
      }
    },
    async getData(d)
    {
      //console.log(1182,d,this.today);
      this.authenticated=1;
      //console.log(2187,this.booking.date);
      this.loading=true;
      this.dialog_connectionError=false;
      try{
          const payload=JSON.stringify({"date": this.booking.date,"action":"walkInLocations_get"});
          const res = await this.$http.post('/manage/manage.php', payload );
          //console.log(1811,res, new Date());
          this.loading= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.locations=res.data.payloads.locations;
                //console.log(2061,this.locations)
                return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }  
      } catch(e)
      {
        this.loading= false;
        this.dialog_connectionError=true;
      }
    },
    proceed()
    {
      if(this.focus)
      {
        this.$refs[this.focus].focus();
      }
      else
      {
        this.checkIfDuplicateBooking();
        /*
        if (this.booking.bookingId||this.settings.options.showWarningBeforeBooking=='0')
        {
          this.process();
        }
        else
        {
          this.dialog_warning_before_booking=1;
          setTimeout(() => {
            this.setLoaded(this.slotForPaypal,20);
          }, 300);
          
        }*/
      }
    },
    async checkIfDuplicateBooking()
    {
      //console.log(973,this.booking)
      this.booking.waitingListTime=this.booking.waiting&&this.booking.waitingListTime>0?this.booking.waitingListTime:null;
      ////console.log(974,this.date,this.slotId,this.locationiId)
      this.loading_book=true;
      if (this.booking.bookingId)
      {
        this.saveBooking();
      }
      else
      {
        let payload={"action":'checkBooking',"payload":JSON.stringify({"phone":this.booking.phone,"countryCode":this.booking.countryCode,"date":this.booking.date,"slotId":this.booking.slotId,"shiftId":this.booking.shiftId})}
        let checkResponse= await this.updateDB(payload);
        //console.log(977,checkResponse)
        this.loading_book=false;
        if (checkResponse&&checkResponse.payloads&&this.booking)
        {
          this.existingBookings=checkResponse.payloads;
          //console.log(982,this.existingBookings.length)
          this.createdDate=this.existingBookings[0].createdDate;
          //console.log(984,this.createdDate,this.createdDate.substring(11,19));
          this.dialog_already_exists=true;
        }
        else
        {
          this.existingBookings=null;
          //this.saveBooking();
          if (this.booking.bookingId||this.settings.options.showWarningBeforeBooking=='0')
          {
            this.saveBooking();
          }
          else
          {
            this.dialog_warning_before_booking=1;
            if (this.paymentRequired)
            {
              //console.log(2456)
              setTimeout(() => {
                this.setLoaded(this.slotForPaypal,20);
              }, 300);
            }              
          }
        }
      }
    },
    async saveBooking(action='saveBooking')
    {
      //this.loading=true;
      //console.log(3019,JSON.stringify(this.booking),JSON.stringify(this.booking.requests))
      //console.log(3020,this.booking.requests)
      //console.log(3021,this.booking.foodStyles)
      //this.booking.requests=this.booking.requests.filter(o => o.value===true).map(f => {const {requestId, value} = f; return {requestId, value}})
      var booking={...this.booking};
      /*if (!booking.bookingId)
      {

        var rq=this.booking.requests.filter(r=>r.value==1).map(r => r.requestId)
        var fs=this.booking.foodStyles.filter(r=>r.value==1).map(r => r.requestId)
        //console.log(1139,booking.requests,booking.foodStyles);

        booking.requests= rq
        booking.foodStyles=fs
      }*/
      booking.sendWAConfirmation=1;
      //console.log(2808,this.freeTables,this.booking.slotId,this.freeTables.find(ft=>ft.slotId==this.booking.slotId).notCompliant)
      booking.notCompliant=this.freeTables.find(ft=>ft.slotId==this.booking.slotId).notCompliant;
      booking.customerId=localStorage.getItem('customerId')
      booking.WAVerification=this.voxNumber;
      booking.validated=this.voxNumber;
      booking.volante=this.freeTables.find(ft=>ft.slotId==this.booking.slotId).manualConfirmation?false:this.voxNumber;
      booking.WAConfirmed=this.voxNumber;
      //booking.WADelivered=this.voxNumber;
      //console.log(1694,this.booking.waitingListTime)
      /*
      if (this.freeTables.find(ft=>ft.slotId==this.booking.slotId).soldOut==0&&this.freeTables.find(ft=>ft.slotId==this.booking.slotId).totalCovers<=this.freeTables.find(ft=>ft.slotId==this.booking.slotId).covers)
      {
        //delete this.booking.waitingListTime;
      }
      */
      //console.log(1699,this.booking.waitingListTime)
      booking.locale=this.settings.locale;
      console.log(3262,this.settings.locale)
      this.loading_book=true;
      this.dialog_booked=true;
      this.open_confirm_dialog=true;
      booking.waitingListTime=this.booking.waitingListTime>0&&this.booking.waiting?this.booking.waitingListTime:null;
      if(this.forceTableAllocation)
      {
        //console.log(2859,booking.slotId,this.freeTables,this.freeTables.find(f=>f.slotId==booking.slotId))
        booking.tables=this.freeTables.find(f=>f.slotId==booking.slotId).newBookingTables;
        booking.tablesId=this.freeTables.find(f=>f.slotId==booking.slotId).newBookingTablesId;
        booking.manual=1;
      }
      //booking.userToken=localStorage.getItem('userToken')
      //var action='saveBooking';
      let payload={"action":action,"payload":booking}
      console.log(2856,payload,booking)
      let w= await this.updateDB(payload)
      ////console.log(992,w,w.errorid);
      this.loading=false;
      this.loading_book=false;
      console.log(3298,w)
      if(w.errorid=='0'&&w.bookingId)
      {
          //console.log(1078,w.rslt,w.json)
          this.bookingRslt=w.json;
          this.bookingId_WA=this.bookingRslt.bookingId;
          this.phone=this.booking.phone;
          this.successfulBooking=true;
          this.booking={...this.booking_clone};
          this.checkingWADelivered=1
          setTimeout(() => {
              this.checkWADelivered(this.bookingId_WA)
            }, 5000);
          //this.removeUser(0);
          //console.log(2810,this.succesfulBooking)
      }		
    },
    async checkWADelivered(bookingId)
    {
      let payload={"action":"checkWADelivered","bookingId":bookingId}
      console.log(3318,payload,bookingId)
      let w= await this.updateDB(payload)
      this.checkingWADelivered=-1;
      this.WADelivered= w.payloads&&w.payloads.delivered>0?1:0;
      console.log(3320,w,w.payloads,this.WADelivered);
    },
    async updateDB(payload)
    {
      try{
          const res = await this.$http.post('/booking/booking.php', payload);
          //console.log(1284,res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
          }
          else
          {
            //console.log(1291);
            //this.$router.push('/auth/login').catch(() => {});
          }
          return res.data;
      } catch(e)
      {
        this.dialog_connection_error=true;
        //console.log(e);
      }
    },
    allowedDates(val)
    {
      ////console.log(1231,val)
      var r= this.bookableDays.find(d=>d.date==val)&&this.bookableDays.find(d=>d.date==val&&d.isDAY_OPEN)||this.settings.options.disableClosedDays=='0'?val:null;
      ////console.log(1233,r)
      return r
    },/*
    functionEvents(val)
    {
      var r= this.bookableDays.find(d=>d.date==val)&&this.bookableDays.find(d=>d.date==val&&d.isOpenDay==0)||this.settings.options.disableClosedDays=='0'?val:null;
      //console.log(1755,val,r)
      return r
    },*/
    allowedDates2(a) {
      return val => ![a].includes(new Date(val).getDay());
    },    
    reset()
    {
      /*this.booking={...this.booking_clone};
      this.tryToGetFreeSlots=false;
      //console.log(2358,this.booking);
      this.booking.requests=JSON.parse(this.requestsCopy);
      this.booking.foodStyles=JSON.parse(this.foodStylesCopy);*/
      this.ppPaid=false;
      this.ppCancel=false;
      this.ppError=false;
      this.dialog_booked = false;
    },
    showNewUserMessage()
    {
      //this.dialog_newUserMessage = (this.show_newUserMessage&&this.newUser)?true:false;
    },
    b64E(str)
    {
      return btoa(encodeURIComponent(str));
    },
    b64D(str) {
      return decodeURIComponent(atob(str));
    }    
  },
};
</script>
<style>
.v-date-picker-table--date .v-btn.theme--dark {
  border-radius:3px!important;
  background-color: #292d32;
  /*
  -webkit-box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;
  box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;    
  */
}
.v-date-picker-table--date .v-btn.theme--light{
  border-radius:3px!important;
  background-color: #ededed;
  /*
  -webkit-box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;
  box-shadow: -3px -3px 4px #3e4247, 5px 5px 5px #1d1f23 !important;    
  */
}
</style>
<style scoped>
.v-btn:before{
  background-color: unset!important;
}
.darkbg{
  background-color: #292d32!important;
}
.lightbg{
  background-color: #f2f3f7!important;
}
.transparent-bg{
  background:transparent!important;
}
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-size: cover;
    background-color: red;
    transform: scale(1.1);
  }
</style>  